(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define('react-product-purchase',["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactProductPurchase"] = factory(require("react"));
	else
		root["ReactProductPurchase"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configure = undefined;
	
	var _ProductPurchase = __webpack_require__(1);
	
	var _ProductPurchase2 = _interopRequireDefault(_ProductPurchase);
	
	var _configureG2mBundles = __webpack_require__(105);
	
	var _configureG2mBundles2 = _interopRequireDefault(_configureG2mBundles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var configure = { configureG2MBundles: _configureG2mBundles2.default };
	
	exports.default = _ProductPurchase2.default;
	exports.configure = configure;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlanForm = __webpack_require__(3);
	
	var _PlanForm2 = _interopRequireDefault(_PlanForm);
	
	var _PlanSelection = __webpack_require__(72);
	
	var _PlanSelection2 = _interopRequireDefault(_PlanSelection);
	
	var _G2MTrialPromo = __webpack_require__(91);
	
	var _G2MTrialPromo2 = _interopRequireDefault(_G2MTrialPromo);
	
	var _translations = __webpack_require__(97);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	var _initializeTranslations = __webpack_require__(98);
	
	var _initializeTranslations2 = _interopRequireDefault(_initializeTranslations);
	
	var _orderedG2mPlanNames = __webpack_require__(102);
	
	var _orderedG2mPlanNames2 = _interopRequireDefault(_orderedG2mPlanNames);
	
	__webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  initialPage: _react.PropTypes.string,
	  language: _react.PropTypes.string,
	  bundles: _react.PropTypes.array,
	  track: _react.PropTypes.func
	};
	
	var defaultProps = {
	  initialPage: 'plan-form',
	  language: 'en',
	  close: function close() {},
	  track: function track() {}
	};
	
	var pageMapping = {
	  'plan-form': _PlanForm2.default,
	  'plan-selection': _PlanSelection2.default,
	  'g2m-trial-promo': _G2MTrialPromo2.default
	};
	
	var ProductPurchase = function (_Component) {
	  _inherits(ProductPurchase, _Component);
	
	  function ProductPurchase(props) {
	    _classCallCheck(this, ProductPurchase);
	
	    var _this = _possibleConstructorReturn(this, (ProductPurchase.__proto__ || Object.getPrototypeOf(ProductPurchase)).call(this, props));
	
	    _this.state = {
	      activePage: props.initialPage,
	      // select Pro plan by default
	      selectedBundle: _this.props.bundles[_orderedG2mPlanNames2.default.indexOf('G2M_Pro2')]
	    };
	
	    (0, _initializeTranslations2.default)({
	      language: _this.props.language,
	      translations: _translations2.default
	    });
	    return _this;
	  }
	
	  _createClass(ProductPurchase, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var ActivePage = pageMapping[this.state.activePage];
	      var changePage = function changePage(pageKey, options) {
	        _this2.setState({ activePage: pageKey });
	        _this2.props.track(pageKey, options);
	      };
	      var changeBundle = function changeBundle(bundleIndex) {
	        return _this2.setState({ selectedBundle: _this2.props.bundles[bundleIndex] });
	      };
	
	      if (!ActivePage) {
	        throw new Error('No matching page found.');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-purchase', id: 'product-purchase' },
	        _react2.default.createElement(ActivePage, _extends({}, this.props, {
	          changePage: changePage,
	          changeBundle: changeBundle,
	          bundle: this.state.selectedBundle
	        }))
	      );
	    }
	  }]);
	
	  return ProductPurchase;
	}(_react.Component);
	
	exports.default = ProductPurchase;
	
	
	ProductPurchase.propTypes = propTypes;
	ProductPurchase.defaultProps = defaultProps;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _convertNumberToPrice2 = __webpack_require__(20);
	
	var _convertNumberToPrice3 = _interopRequireDefault(_convertNumberToPrice2);
	
	var _Heading = __webpack_require__(21);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Separator = __webpack_require__(26);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _BillingCycleSelection = __webpack_require__(29);
	
	var _BillingCycleSelection2 = _interopRequireDefault(_BillingCycleSelection);
	
	var _ChangePlan = __webpack_require__(41);
	
	var _ChangePlan2 = _interopRequireDefault(_ChangePlan);
	
	var _Footer = __webpack_require__(44);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FormField = __webpack_require__(55);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormRadioField = __webpack_require__(58);
	
	var _FormRadioField2 = _interopRequireDefault(_FormRadioField);
	
	var _NumberInput = __webpack_require__(61);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	__webpack_require__(64);
	
	var _TotalPrice = __webpack_require__(66);
	
	var _TotalPrice2 = _interopRequireDefault(_TotalPrice);
	
	var _Close = __webpack_require__(69);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  bundle: _react.PropTypes.object,
	  changePage: _react.PropTypes.func.isRequired,
	  commerceUrl: _react.PropTypes.string.isRequired,
	  catalogKey: _react.PropTypes.number.isRequired,
	  track: _react.PropTypes.func,
	  close: _react.PropTypes.func.isRequired
	};
	
	var PlanForm = function (_Component) {
	  _inherits(PlanForm, _Component);
	
	  function PlanForm(props) {
	    _classCallCheck(this, PlanForm);
	
	    var _this = _possibleConstructorReturn(this, (PlanForm.__proto__ || Object.getPrototypeOf(PlanForm)).call(this, props));
	
	    _this.state = {
	      selectedPlanKey: props.bundle.plans.find(function (plan) {
	        return plan.period === 'YEAR';
	      }).key,
	      organizerCount: 1
	    };
	    return _this;
	  }
	
	  _createClass(PlanForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var planName = this.props.bundle.name.replace('G2M', 'GoToMeeting');
	      var selectedPlan = this.props.bundle.plans.find(function (plan) {
	        return plan.key === _this2.state.selectedPlanKey;
	      });
	
	      var _convertNumberToPrice = (0, _convertNumberToPrice3.default)(selectedPlan.listPrice * this.state.organizerCount),
	          priceInteger = _convertNumberToPrice.priceInteger,
	          priceFractional = _convertNumberToPrice.priceFractional;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'plan-form' },
	        _react2.default.createElement(_Close2.default, { onClick: this.props.close }),
	        _react2.default.createElement(_Heading2.default, {
	          text: _i18next2.default.t('Almost there!'),
	          subText: _i18next2.default.t('Choose your billing cycle and number of organizers')
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'list-unstyled' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: _i18next2.default.t('Plan'), isPrimary: true },
	              _react2.default.createElement(_ChangePlan2.default, {
	                id: 'plan-form-change-plan',
	                text: planName,
	                onClick: function onClick() {
	                  return _this2.props.changePage('plan-selection');
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _FormRadioField2.default,
	              { label: _i18next2.default.t('Billing Cycle') },
	              _react2.default.createElement(_BillingCycleSelection2.default, {
	                selectedPlanPeriod: selectedPlan.period,
	                plans: this.props.bundle.plans,
	                currencySymbol: this.props.bundle.currencySymbol,
	                selectPlanKey: function selectPlanKey(key) {
	                  return _this2.setState({ selectedPlanKey: key });
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: _i18next2.default.t('No. of Organizers') },
	              _react2.default.createElement(_NumberInput2.default, {
	                id: 'plan-form-number-input',
	                value: this.state.organizerCount,
	                min: '1',
	                description: _i18next2.default.t('Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.'),
	                onChange: function onChange(count) {
	                  return _this2.setState({ organizerCount: count });
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(_Separator2.default, null),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _FormField2.default,
	              { label: _i18next2.default.t('My Total'), isPrimary: true },
	              _react2.default.createElement(_TotalPrice2.default, {
	                id: 'plan-form-total',
	                organizerCount: this.state.organizerCount,
	                currencySymbol: this.props.bundle.currencySymbol,
	                priceInteger: priceInteger,
	                priceFractional: priceFractional,
	                description: selectedPlan.period === 'YEAR' ? _i18next2.default.t('for 1 year') : _i18next2.default.t('for 1 month')
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          commerceUrl: this.props.commerceUrl,
	          productKey: selectedPlan.product,
	          quantities: this.state.organizerCount,
	          planKeys: this.state.selectedPlanKey,
	          catalogKey: this.props.catalogKey,
	          track: this.props.track
	        })
	      );
	    }
	  }]);
	
	  return PlanForm;
	}(_react.Component);
	
	exports.default = PlanForm;
	
	
	PlanForm.propTypes = propTypes;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5).default;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(6);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _i18next2.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(8);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _ResourceStore = __webpack_require__(9);
	
	var _ResourceStore2 = _interopRequireDefault(_ResourceStore);
	
	var _Translator = __webpack_require__(11);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _LanguageUtils = __webpack_require__(14);
	
	var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);
	
	var _PluralResolver = __webpack_require__(15);
	
	var _PluralResolver2 = _interopRequireDefault(_PluralResolver);
	
	var _Interpolator = __webpack_require__(16);
	
	var _Interpolator2 = _interopRequireDefault(_Interpolator);
	
	var _BackendConnector = __webpack_require__(17);
	
	var _BackendConnector2 = _interopRequireDefault(_BackendConnector);
	
	var _CacheConnector = __webpack_require__(18);
	
	var _CacheConnector2 = _interopRequireDefault(_CacheConnector);
	
	var _defaults2 = __webpack_require__(19);
	
	var _postProcessor = __webpack_require__(12);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(13);
	
	var compat = _interopRequireWildcard(_v);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var I18n = function (_EventEmitter) {
	  _inherits(I18n, _EventEmitter);
	
	  function I18n() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.options = (0, _defaults2.transformOptions)(options);
	    _this.services = {};
	    _this.logger = _logger2.default;
	    _this.modules = {};
	
	    if (callback && !_this.isInitialized) _this.init(options, callback);
	    return _this;
	  }
	
	  I18n.prototype.init = function init(options, callback) {
	    var _this2 = this;
	
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.compatibilityAPI === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertAPIOptions(options)), {});
	    } else if (options.compatibilityJSON === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertJSONOptions(options)), {});
	    } else {
	      this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
	    }
	    if (!callback) callback = function callback() {};
	
	    function createClassOnDemand(ClassOrObject) {
	      if (!ClassOrObject) return;
	      if (typeof ClassOrObject === 'function') return new ClassOrObject();
	      return ClassOrObject;
	    }
	
	    // init services
	    if (!this.options.isClone) {
	      if (this.modules.logger) {
	        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
	      } else {
	        _logger2.default.init(null, this.options);
	      }
	
	      var lu = new _LanguageUtils2.default(this.options);
	      this.store = new _ResourceStore2.default(this.options.resources, this.options);
	
	      var s = this.services;
	      s.logger = _logger2.default;
	      s.resourceStore = this.store;
	      s.resourceStore.on('added removed', function (lng, ns) {
	        s.cacheConnector.save();
	      });
	      s.languageUtils = lu;
	      s.pluralResolver = new _PluralResolver2.default(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON });
	      s.interpolator = new _Interpolator2.default(this.options);
	
	      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.backendConnector.on('*', function (event) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      s.backendConnector.on('loaded', function (loaded) {
	        s.cacheConnector.save();
	      });
	
	      s.cacheConnector = new _CacheConnector2.default(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.cacheConnector.on('*', function (event) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      if (this.modules.languageDetector) {
	        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	        s.languageDetector.init(s, this.options.detection, this.options);
	      }
	
	      this.translator = new _Translator2.default(this.services, this.options);
	      // pipe events from translator
	      this.translator.on('*', function (event) {
	        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	          args[_key3 - 1] = arguments[_key3];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	    }
	
	    // append api
	    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
	    storeApi.forEach(function (fcName) {
	      _this2[fcName] = function () {
	        return this.store[fcName].apply(this.store, arguments);
	      };
	    });
	
	    // TODO: COMPATIBILITY remove this
	    if (this.options.compatibilityAPI === 'v1') compat.appendBackwardsAPI(this);
	
	    var load = function load() {
	      _this2.changeLanguage(_this2.options.lng, function (err, t) {
	        _this2.emit('initialized', _this2.options);
	        _this2.logger.log('initialized', _this2.options);
	
	        callback(err, t);
	      });
	    };
	
	    if (this.options.resources || !this.options.initImmediate) {
	      load();
	    } else {
	      setTimeout(load, 0);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.loadResources = function loadResources(callback) {
	    var _this3 = this;
	
	    if (!callback) callback = function callback() {};
	
	    if (!this.options.resources) {
	      var _ret = function () {
	        if (_this3.language && _this3.language.toLowerCase() === 'cimode') return {
	            v: callback()
	          }; // avoid loading resources for cimode
	
	        var toLoad = [];
	
	        var append = function append(lng) {
	          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	          lngs.forEach(function (l) {
	            if (toLoad.indexOf(l) < 0) toLoad.push(l);
	          });
	        };
	
	        append(_this3.language);
	
	        if (_this3.options.preload) {
	          _this3.options.preload.forEach(function (l) {
	            append(l);
	          });
	        }
	
	        _this3.services.cacheConnector.load(toLoad, _this3.options.ns, function () {
	          _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
	        });
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    } else {
	      callback(null);
	    }
	  };
	
	  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
	    if (!lngs) lngs = this.languages;
	    if (!ns) ns = this.options.ns;
	    this.services.backendConnector.reload(lngs, ns);
	  };
	
	  I18n.prototype.use = function use(module) {
	    if (module.type === 'backend') {
	      this.modules.backend = module;
	    }
	
	    if (module.type === 'cache') {
	      this.modules.cache = module;
	    }
	
	    if (module.type === 'logger' || module.log && module.warn && module.warn) {
	      this.modules.logger = module;
	    }
	
	    if (module.type === 'languageDetector') {
	      this.modules.languageDetector = module;
	    }
	
	    if (module.type === 'postProcessor') {
	      _postProcessor2.default.addPostProcessor(module);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
	    var _this4 = this;
	
	    var done = function done(err) {
	      if (lng) {
	        _this4.emit('languageChanged', lng);
	        _this4.logger.log('languageChanged', lng);
	      }
	
	      if (callback) callback(err, function () {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        return _this4.t.apply(_this4, args);
	      });
	    };
	
	    if (!lng && this.services.languageDetector) lng = this.services.languageDetector.detect();
	
	    if (lng) {
	      this.language = lng;
	      this.languages = this.services.languageUtils.toResolveHierarchy(lng);
	
	      this.translator.changeLanguage(lng);
	
	      if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(lng);
	    }
	
	    this.loadResources(function (err) {
	      done(err);
	    });
	  };
	
	  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
	    var _this5 = this;
	
	    var fixedT = function fixedT(key, options) {
	      options = options || {};
	      options.lng = options.lng || fixedT.lng;
	      options.ns = options.ns || fixedT.ns;
	      return _this5.t(key, options);
	    };
	    fixedT.lng = lng;
	    fixedT.ns = ns;
	    return fixedT;
	  };
	
	  I18n.prototype.t = function t() {
	    return this.translator && this.translator.translate.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.exists = function exists() {
	    return this.translator && this.translator.exists.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
	    this.options.defaultNS = ns;
	  };
	
	  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
	    var _this6 = this;
	
	    if (!this.options.ns) return callback && callback();
	    if (typeof ns === 'string') ns = [ns];
	
	    ns.forEach(function (n) {
	      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
	    });
	
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
	    if (typeof lngs === 'string') lngs = [lngs];
	    var preloaded = this.options.preload || [];
	
	    var newLngs = lngs.filter(function (lng) {
	      return preloaded.indexOf(lng) < 0;
	    });
	    // Exit early if all given languages are already preloaded
	    if (!newLngs.length) return callback();
	
	    this.options.preload = preloaded.concat(newLngs);
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.dir = function dir(lng) {
	    if (!lng) lng = this.language;
	    if (!lng) return 'rtl';
	
	    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	
	    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	  };
	
	  I18n.prototype.createInstance = function createInstance() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    return new I18n(options, callback);
	  };
	
	  I18n.prototype.cloneInstance = function cloneInstance() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    var clone = new I18n(_extends({}, options, this.options, { isClone: true }), callback);
	    var membersToCopy = ['store', 'services', 'language'];
	    membersToCopy.forEach(function (m) {
	      clone[m] = _this7[m];
	    });
	    clone.translator = new _Translator2.default(clone.services, clone.options);
	    clone.translator.on('*', function (event) {
	      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        args[_key5 - 1] = arguments[_key5];
	      }
	
	      clone.emit.apply(clone, [event].concat(args));
	    });
	
	    return clone;
	  };
	
	  return I18n;
	}(_EventEmitter3.default);
	
	exports.default = new I18n();

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consoleLogger = {
	  type: 'logger',
	
	  log: function log(args) {
	    this._output('log', args);
	  },
	  warn: function warn(args) {
	    this._output('warn', args);
	  },
	  error: function error(args) {
	    this._output('error', args);
	  },
	  _output: function _output(type, args) {
	    if (console && console[type]) console[type].apply(console, Array.prototype.slice.call(args));
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Logger);
	
	    this.subs = [];
	    this.init(concreteLogger, options);
	  }
	
	  Logger.prototype.init = function init(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.prefix = options.prefix || 'i18next:';
	    this.logger = concreteLogger || consoleLogger;
	    this.options = options;
	    this.debug = options.debug === false ? false : true;
	  };
	
	  Logger.prototype.setDebug = function setDebug(bool) {
	    this.debug = bool;
	    this.subs.forEach(function (sub) {
	      sub.setDebug(bool);
	    });
	  };
	
	  Logger.prototype.log = function log() {
	    this.forward(arguments, 'log', '', true);
	  };
	
	  Logger.prototype.warn = function warn() {
	    this.forward(arguments, 'warn', '', true);
	  };
	
	  Logger.prototype.error = function error() {
	    this.forward(arguments, 'error', '');
	  };
	
	  Logger.prototype.deprecate = function deprecate() {
	    this.forward(arguments, 'warn', 'WARNING DEPRECATED: ', true);
	  };
	
	  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
	    if (debugOnly && !this.debug) return;
	    if (typeof args[0] === 'string') args[0] = prefix + this.prefix + ' ' + args[0];
	    this.logger[lvl](args);
	  };
	
	  Logger.prototype.create = function create(moduleName) {
	    var sub = new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
	    this.subs.push(sub);
	
	    return sub;
	  };
	
	  // createInstance(options = {}) {
	  //   return new Logger(options, callback);
	  // }
	
	  return Logger;
	}();
	
	;
	
	exports.default = new Logger();

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
		function EventEmitter() {
			_classCallCheck(this, EventEmitter);
	
			this.observers = {};
		}
	
		EventEmitter.prototype.on = function on(events, listener) {
			var _this = this;
	
			events.split(' ').forEach(function (event) {
				_this.observers[event] = _this.observers[event] || [];
				_this.observers[event].push(listener);
			});
		};
	
		EventEmitter.prototype.off = function off(event, listener) {
			var _this2 = this;
	
			if (!this.observers[event]) {
				return;
			}
	
			this.observers[event].forEach(function () {
				if (!listener) {
					delete _this2.observers[event];
				} else {
					var index = _this2.observers[event].indexOf(listener);
					if (index > -1) {
						_this2.observers[event].splice(index, 1);
					}
				}
			});
		};
	
		EventEmitter.prototype.emit = function emit(event) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}
	
			if (this.observers[event]) {
				this.observers[event].forEach(function (observer) {
					observer.apply(undefined, args);
				});
			}
	
			if (this.observers['*']) {
				this.observers['*'].forEach(function (observer) {
					var _ref;
	
					observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
				});
			}
		};
	
		return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EventEmitter2 = __webpack_require__(8);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _utils = __webpack_require__(10);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits(ResourceStore, _EventEmitter);
	
	  function ResourceStore() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };
	
	    _classCallCheck(this, ResourceStore);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.data = data;
	    _this.options = options;
	    return _this;
	  }
	
	  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
	    if (this.options.ns.indexOf(ns) < 0) {
	      this.options.ns.push(ns);
	    }
	  };
	
	  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
	    var index = this.options.ns.indexOf(ns);
	    if (index > -1) {
	      this.options.ns.splice(index, 1);
	    }
	  };
	
	  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var keySeparator = options.keySeparator || this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key && typeof key !== 'string') path = path.concat(key);
	    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	    }
	
	    return utils.getPath(this.data, path);
	  };
	
	  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };
	
	    var keySeparator = this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      value = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    utils.setPath(this.data, path, value);
	
	    if (!options.silent) this.emit('added', lng, ns, key, value);
	  };
	
	  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
	    for (var m in resources) {
	      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
	    }
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
	    var path = [lng, ns];
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      deep = resources;
	      resources = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    var pack = utils.getPath(this.data, path) || {};
	
	    if (deep) {
	      utils.deepExtend(pack, resources, overwrite);
	    } else {
	      pack = _extends({}, pack, resources);
	    }
	
	    utils.setPath(this.data, path, pack);
	
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
	    if (this.hasResourceBundle(lng, ns)) {
	      delete this.data[lng][ns];
	    }
	    this.removeNamespaces(ns);
	
	    this.emit('removed', lng, ns);
	  };
	
	  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
	    return this.getResource(lng, ns) !== undefined;
	  };
	
	  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
	    if (!ns) ns = this.options.defaultNS;
	
	    // TODO: COMPATIBILITY remove extend in v2.1.0
	    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));
	
	    return this.getResource(lng, ns);
	  };
	
	  ResourceStore.prototype.toJSON = function toJSON() {
	    return this.data;
	  };
	
	  return ResourceStore;
	}(_EventEmitter3.default);
	
	exports.default = ResourceStore;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeString = makeString;
	exports.copy = copy;
	exports.setPath = setPath;
	exports.pushPath = pushPath;
	exports.getPath = getPath;
	exports.deepExtend = deepExtend;
	exports.regexEscape = regexEscape;
	exports.escape = escape;
	function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	}
	
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (!object) return {};
	
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    object = object[key];
	  }
	
	  if (!object) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	
	function deepExtend(target, source, overwrite) {
	  for (var prop in source) {
	    if (prop in target) {
	      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
	      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	        if (overwrite) target[prop] = source[prop];
	      } else {
	        deepExtend(target[prop], source[prop], overwrite);
	      }
	    } else {
	      target[prop] = source[prop];
	    }
	  }return target;
	}
	
	function regexEscape(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/* eslint-disable */
	var _entityMap = {
	  "&": "&amp;",
	  "<": "&lt;",
	  ">": "&gt;",
	  '"': '&quot;',
	  "'": '&#39;',
	  "/": '&#x2F;'
	};
	/* eslint-enable */
	
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  } else {
	    return data;
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(8);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _postProcessor = __webpack_require__(12);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(13);
	
	var compat = _interopRequireWildcard(_v);
	
	var _utils = __webpack_require__(10);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Translator = function (_EventEmitter) {
	  _inherits(Translator, _EventEmitter);
	
	  function Translator(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Translator);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);
	
	    _this.options = options;
	    _this.logger = _logger2.default.create('translator');
	    return _this;
	  }
	
	  Translator.prototype.changeLanguage = function changeLanguage(lng) {
	    if (lng) this.language = lng;
	  };
	
	  Translator.prototype.exists = function exists(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };
	
	    if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    return this.resolve(key, options) !== undefined;
	  };
	
	  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
	    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	    if (nsSeparator === undefined) nsSeparator = ':';
	
	    var namespaces = options.ns || this.options.defaultNS;
	    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	      var parts = key.split(nsSeparator);
	      namespaces = parts[0];
	      key = parts[1];
	    }
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    return {
	      key: key,
	      namespaces: namespaces
	    };
	  };
	
	  Translator.prototype.translate = function translate(keys) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	      options = this.options.overloadTranslationOptionHandler(arguments);
	    } else if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    // non valid keys handling
	    if (keys === undefined || keys === null || keys === '') return '';
	    if (typeof keys === 'number') keys = String(keys);
	    if (typeof keys === 'string') keys = [keys];
	
	    // return key on CIMode
	    var lng = options.lng || this.language;
	    if (lng && lng.toLowerCase() === 'cimode') return keys[keys.length - 1];
	
	    // separators
	    var keySeparator = options.keySeparator || this.options.keySeparator || '.';
	
	    // get namespace(s)
	
	    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _extractFromKey.key,
	        namespaces = _extractFromKey.namespaces;
	
	    var namespace = namespaces[namespaces.length - 1];
	
	    // resolve from store
	    var res = this.resolve(keys, options);
	
	    var resType = Object.prototype.toString.apply(res);
	    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	
	    // object
	    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
	      if (!options.returnObjects && !this.options.returnObjects) {
	        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
	      }
	
	      var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy
	
	      for (var m in res) {
	        copy[m] = this.translate('' + key + keySeparator + m, _extends({ joinArrays: false, ns: namespaces }, options));
	      }
	      res = copy;
	    }
	    // array special treatment
	    else if (joinArrays && resType === '[object Array]') {
	        res = res.join(joinArrays);
	        if (res) res = this.extendTranslation(res, key, options);
	      }
	      // string, empty or null
	      else {
	          var usedDefault = false,
	              usedKey = false;
	
	          // fallback value
	          if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
	            usedDefault = true;
	            res = options.defaultValue;
	          }
	          if (!this.isValidLookup(res)) {
	            usedKey = true;
	            res = key;
	          }
	
	          // save missing
	          if (usedKey || usedDefault) {
	            this.logger.log('missingKey', lng, namespace, key, res);
	
	            var lngs = [];
	            var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	            if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	              for (var i = 0; i < fallbackLngs.length; i++) {
	                lngs.push(fallbackLngs[i]);
	              }
	            } else if (this.options.saveMissingTo === 'all') {
	              lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	            } else {
	              //(this.options.saveMissingTo === 'current' || (this.options.saveMissingTo === 'fallback' && this.options.fallbackLng[0] === false) ) {
	              lngs.push(options.lng || this.language);
	            }
	
	            if (this.options.saveMissing) {
	              if (this.options.missingKeyHandler) {
	                this.options.missingKeyHandler(lngs, namespace, key, res);
	              } else if (this.backendConnector && this.backendConnector.saveMissing) {
	                this.backendConnector.saveMissing(lngs, namespace, key, res);
	              }
	            }
	
	            this.emit('missingKey', lngs, namespace, key, res);
	          }
	
	          // extend
	          res = this.extendTranslation(res, key, options);
	
	          // append namespace if still key
	          if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;
	
	          // parseMissingKeyHandler
	          if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	        }
	
	    // return
	    return res;
	  };
	
	  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
	    var _this2 = this;
	
	    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));
	
	    // interpolate
	    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
	    res = this.interpolator.interpolate(res, data, this.language);
	
	    // nesting
	    res = this.interpolator.nest(res, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _this2.translate.apply(_this2, args);
	    }, options);
	
	    if (options.interpolation) this.interpolator.reset();
	
	    // post process
	    var postProcess = options.postProcess || this.options.postProcess;
	    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
	    }
	
	    return res;
	  };
	
	  Translator.prototype.resolve = function resolve(keys) {
	    var _this3 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var found = void 0;
	
	    if (typeof keys === 'string') keys = [keys];
	
	    // forEach possible key
	    keys.forEach(function (k) {
	      if (_this3.isValidLookup(found)) return;
	
	      var _extractFromKey2 = _this3.extractFromKey(k, options),
	          key = _extractFromKey2.key,
	          namespaces = _extractFromKey2.namespaces;
	
	      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);
	
	      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	
	      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);
	
	      namespaces.forEach(function (ns) {
	        if (_this3.isValidLookup(found)) return;
	
	        codes.forEach(function (code) {
	          if (_this3.isValidLookup(found)) return;
	
	          var finalKey = key;
	          var finalKeys = [finalKey];
	
	          var pluralSuffix = void 0;
	          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);
	
	          // fallback for plural if context not found
	          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	
	          // get key for context if needed
	          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);
	
	          // get key for plural if needed
	          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	
	          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
	          var possibleKey = void 0;
	          while (possibleKey = finalKeys.pop()) {
	            if (_this3.isValidLookup(found)) continue;
	            found = _this3.getResource(code, ns, possibleKey, options);
	          }
	        });
	      });
	    });
	
	    return found;
	  };
	
	  Translator.prototype.isValidLookup = function isValidLookup(res) {
	    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	  };
	
	  Translator.prototype.getResource = function getResource(code, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return this.resourceStore.getResource(code, ns, key, options);
	  };
	
	  return Translator;
	}(_EventEmitter3.default);
	
	exports.default = Translator;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  processors: {},
	
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	
	    return value;
	  }
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertAPIOptions = convertAPIOptions;
	exports.convertJSONOptions = convertJSONOptions;
	exports.convertTOptions = convertTOptions;
	exports.appendBackwardsAPI = appendBackwardsAPI;
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function convertInterpolation(options) {
	
	  options.interpolation = {
	    unescapeSuffix: 'HTML'
	  };
	
	  options.interpolation.prefix = options.interpolationPrefix || '__';
	  options.interpolation.suffix = options.interpolationSuffix || '__';
	  options.interpolation.escapeValue = options.escapeInterpolation || false;
	
	  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
	  options.interpolation.nestingSuffix = options.reuseSuffix || ')';
	
	  return options;
	}
	
	function convertAPIOptions(options) {
	  if (options.resStore) options.resources = options.resStore;
	
	  if (options.ns && options.ns.defaultNs) {
	    options.defaultNS = options.ns.defaultNs;
	    options.ns = options.ns.namespaces;
	  } else {
	    options.defaultNS = options.ns || 'translation';
	  }
	
	  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;
	
	  options.saveMissing = options.sendMissing;
	  options.saveMissingTo = options.sendMissingTo || 'current';
	  options.returnNull = options.fallbackOnNull ? false : true;
	  options.returnEmptyString = options.fallbackOnEmpty ? false : true;
	  options.returnObjects = options.returnObjectTrees;
	  options.joinArrays = '\n';
	
	  options.returnedObjectHandler = options.objectTreeKeyHandler;
	  options.parseMissingKeyHandler = options.parseMissingKey;
	  options.appendNamespaceToMissingKey = true;
	
	  options.nsSeparator = options.nsseparator;
	  options.keySeparator = options.keyseparator;
	
	  if (options.shortcutFunction === 'sprintf') {
	    options.overloadTranslationOptionHandler = function (args) {
	      var values = [];
	
	      for (var i = 1; i < args.length; i++) {
	        values.push(args[i]);
	      }
	
	      return {
	        postProcess: 'sprintf',
	        sprintf: values
	      };
	    };
	  }
	
	  options.whitelist = options.lngWhitelist;
	  options.preload = options.preload;
	  if (options.load === 'current') options.load = 'currentOnly';
	  if (options.load === 'unspecific') options.load = 'languageOnly';
	
	  // backend
	  options.backend = options.backend || {};
	  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
	  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
	  options.backend.allowMultiLoading = options.dynamicLoad;
	
	  // cache
	  options.cache = options.cache || {};
	  options.cache.prefix = 'res_';
	  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
	  options.cache.enabled = options.useLocalStorage ? true : false;
	
	  options = convertInterpolation(options);
	  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;
	
	  // TODO: deprecation
	  // if (options.getAsync === false) throw deprecation error
	
	  return options;
	}
	
	function convertJSONOptions(options) {
	  options = convertInterpolation(options);
	  options.joinArrays = '\n';
	
	  return options;
	}
	
	function convertTOptions(options) {
	  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation) {
	    options = convertInterpolation(options);
	  }
	
	  options.nsSeparator = options.nsseparator;
	  options.keySeparator = options.keyseparator;
	
	  options.returnObjects = options.returnObjectTrees;
	
	  return options;
	}
	
	function appendBackwardsAPI(i18n) {
	  i18n.lng = function () {
	    _logger2.default.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
	    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
	  };
	
	  i18n.preload = function (lngs, cb) {
	    _logger2.default.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
	    i18n.loadLanguages(lngs, cb);
	  };
	
	  i18n.setLng = function (lng, options, callback) {
	    _logger2.default.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.fixLng === true) {
	      if (callback) return callback(null, i18n.getFixedT(lng));
	    }
	
	    i18n.changeLanguage(lng, callback);
	  };
	
	  i18n.addPostProcessor = function (name, fc) {
	    _logger2.default.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
	    i18n.use({
	      type: 'postProcessor',
	      name: name,
	      process: fc
	    });
	  };
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck(this, LanguageUtil);
	
	    this.options = options;
	
	    this.whitelist = this.options.whitelist || false;
	    this.logger = _logger2.default.create('languageUtils');
	  }
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (code.indexOf('-') < 0) return code;
	
	    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
	    var p = code.split('-');
	    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
	  };
	
	  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
	    if (code.indexOf('-') < 0) return null;
	
	    var p = code.split('-');
	    if (p.length === 2) return null;
	    p.pop();
	    return this.formatLanguageCode(p.join('-'));
	  };
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (code.indexOf('-') < 0) return code;
	
	    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
	    var p = code.split('-');
	    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
	  };
	
	  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
	    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	      var p = code.split('-');
	
	      if (this.options.lowerCaseLng) {
	        p = p.map(function (part) {
	          return part.toLowerCase();
	        });
	      } else if (p.length === 2) {
	        p[0] = p[0].toLowerCase();
	        p[1] = p[1].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	      } else if (p.length === 3) {
	        p[0] = p[0].toLowerCase();
	
	        // if lenght 2 guess it's a country
	        if (p[1].length === 2) p[1] = p[1].toUpperCase();
	        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	      }
	
	      return p.join('-');
	    } else {
	      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	    }
	  };
	
	  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code, exactMatch) {
	    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist && !exactMatch) {
	      code = this.getLanguagePartFromCode(code);
	    }
	    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1 ? true : false;
	  };
	
	  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
	    if (!fallbacks) return [];
	    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	
	    // asume we have an object defining fallbacks
	    var found = fallbacks[code];
	    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	    if (!found) found = fallbacks[this.formatLanguageCode(code)];
	    if (!found) found = fallbacks.default;
	
	    return found || [];
	  };
	
	  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
	    var _this = this;
	
	    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	
	    var codes = [];
	    var addCode = function addCode(code) {
	      var exactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!code) return;
	      if (_this.isWhitelisted(code, exactMatch)) {
	        codes.push(code);
	      } else {
	        _this.logger.warn('rejecting non-whitelisted language code: ' + code);
	      }
	    };
	
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code), true);
	      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code), true);
	      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	    } else if (typeof code === 'string') {
	      addCode(this.formatLanguageCode(code));
	    }
	
	    fallbackCodes.forEach(function (fc) {
	      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
	    });
	
	    return codes;
	  };
	
	  return LanguageUtil;
	}();
	
	;
	
	exports.default = LanguageUtil;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
	/* eslint-disable */
	var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];
	
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  }
	};
	/* eslint-enable */
	
	function createRules() {
	  var l,
	      rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      return rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	
	    this.logger = _logger2.default.create('pluralResolver');
	
	    this.rules = createRules();
	  }
	
	  PluralResolver.prototype.addRule = function addRule(lng, obj) {
	    this.rules[lng] = obj;
	  };
	
	  PluralResolver.prototype.getRule = function getRule(code) {
	    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	  };
	
	  PluralResolver.prototype.needsPlural = function needsPlural(code) {
	    var rule = this.getRule(code);
	
	    return rule && rule.numbers.length <= 1 ? false : true;
	  };
	
	  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
	    var _this = this;
	
	    var rule = this.getRule(code);
	
	    if (rule) {
	      var _ret = function () {
	        if (rule.numbers.length === 1) return {
	            v: ''
	          }; // only singular
	
	        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	        var suffix = rule.numbers[idx];
	
	        // special treatment for lngs only having singular and plural
	        if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
	          if (suffix === 2) {
	            suffix = 'plural';
	          } else if (suffix === 1) {
	            suffix = '';
	          }
	        }
	
	        var returnSuffix = function returnSuffix() {
	          return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
	        };
	
	        // COMPATIBILITY JSON
	        // v1
	        if (_this.options.compatibilityJSON === 'v1') {
	          if (suffix === 1) return {
	              v: ''
	            };
	          if (typeof suffix === 'number') return {
	              v: '_plural_' + suffix.toString()
	            };
	          return {
	            v: returnSuffix()
	          };
	        }
	        // v2
	        else if (_this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
	            return {
	              v: returnSuffix()
	            };
	          }
	          // v3 - gettext index
	          else if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
	              return {
	                v: returnSuffix()
	              };
	            }
	        return {
	          v: _this.options.prepend && idx.toString() ? _this.options.prepend + idx.toString() : idx.toString()
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    } else {
	      this.logger.warn('no plural rule found for: ' + code);
	      return '';
	    }
	  };
	
	  return PluralResolver;
	}();
	
	;
	
	exports.default = PluralResolver;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(10);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Interpolator);
	
	    this.logger = _logger2.default.create('interpolator');
	
	    this.init(options, true);
	  }
	
	  Interpolator.prototype.init = function init() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var reset = arguments[1];
	
	    if (reset) {
	      this.options = options;
	      this.format = options.interpolation && options.interpolation.format || function (value) {
	        return value;
	      };
	    }
	    if (!options.interpolation) options.interpolation = { escapeValue: true };
	
	    var iOpts = options.interpolation;
	
	    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	
	    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	    this.formatSeparator = iOpts.formatSeparator ? utils.regexEscape(iOpts.formatSeparator) : iOpts.formatSeparator || ',';
	
	    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	
	    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
	    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');
	
	    // the regexp
	    this.resetRegExp();
	  };
	
	  Interpolator.prototype.reset = function reset() {
	    if (this.options) this.init(this.options);
	  };
	
	  Interpolator.prototype.resetRegExp = function resetRegExp() {
	    // the regexp
	    var regexpStr = this.prefix + '(.+?)' + this.suffix;
	    this.regexp = new RegExp(regexpStr, 'g');
	
	    var regexpUnescapeStr = this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
	    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	
	    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
	    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	  };
	
	  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
	    var _this = this;
	
	    var match = void 0,
	        value = void 0;
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    var handleFormat = function handleFormat(key) {
	      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);
	
	      var p = key.split(_this.formatSeparator);
	      var k = p.shift().trim();
	      var f = p.join(_this.formatSeparator).trim();
	
	      return _this.format(utils.getPath(data, k), f, lng);
	    };
	
	    this.resetRegExp();
	
	    // unescape if has unescapePrefix/Suffix
	    while (match = this.regexpUnescape.exec(str)) {
	      var _value = handleFormat(match[1].trim());
	      str = str.replace(match[0], _value);
	      this.regexpUnescape.lastIndex = 0;
	    }
	
	    // regular escape on demand
	    while (match = this.regexp.exec(str)) {
	      value = handleFormat(match[1].trim());
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  Interpolator.prototype.nest = function nest(str, fc) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var match = void 0,
	        value = void 0;
	
	    var clonedOptions = JSON.parse(JSON.stringify(options));
	    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
	    function handleHasOptions(key) {
	      if (key.indexOf(',') < 0) return key;
	
	      var p = key.split(',');
	      key = p.shift();
	      var optionsString = p.join(',');
	      optionsString = this.interpolate(optionsString, clonedOptions);
	
	      try {
	        clonedOptions = JSON.parse(optionsString);
	      } catch (e) {
	        this.logger.error('failed parsing options string in nesting for key ' + key, e);
	      }
	
	      return key;
	    }
	
	    // regular escape on demand
	    while (match = this.nestingRegexp.exec(str)) {
	      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  return Interpolator;
	}();
	
	exports.default = Interpolator;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(10);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(8);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('backendConnector');
	
	    _this.state = {};
	    _this.queue = [];
	
	    _this.backend && _this.backend.init && _this.backend.init(services, options.backend, options);
	    return _this;
	  }
	
	  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
	    var _this2 = this;
	
	    // find what needs to be loaded
	    var toLoad = [],
	        pending = [],
	        toLoadLanguages = [],
	        toLoadNamespaces = [];
	
	    languages.forEach(function (lng) {
	      var hasAllNamespaces = true;
	
	      namespaces.forEach(function (ns) {
	        var name = lng + '|' + ns;
	
	        if (_this2.store.hasResourceBundle(lng, ns)) {
	          _this2.state[name] = 2; // loaded
	        } else if (_this2.state[name] < 0) {
	          // nothing to do for err
	        } else if (_this2.state[name] === 1) {
	          if (pending.indexOf(name) < 0) pending.push(name);
	        } else {
	          _this2.state[name] = 1; // pending
	
	          hasAllNamespaces = false;
	
	          if (pending.indexOf(name) < 0) pending.push(name);
	          if (toLoad.indexOf(name) < 0) toLoad.push(name);
	          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	        }
	      });
	
	      if (!hasAllNamespaces) toLoadLanguages.push(lng);
	    });
	
	    if (toLoad.length || pending.length) {
	      this.queue.push({
	        pending: pending,
	        loaded: {},
	        errors: [],
	        callback: callback
	      });
	    }
	
	    return {
	      toLoad: toLoad,
	      pending: pending,
	      toLoadLanguages: toLoadLanguages,
	      toLoadNamespaces: toLoadNamespaces
	    };
	  };
	
	  Connector.prototype.loaded = function loaded(name, err, data) {
	    var _this3 = this;
	
	    var _name$split = name.split('|'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        lng = _name$split2[0],
	        ns = _name$split2[1];
	
	    if (err) this.emit('failedLoading', lng, ns, err);
	
	    if (data) {
	      this.store.addResourceBundle(lng, ns, data);
	    }
	
	    // set loaded
	    this.state[name] = err ? -1 : 2;
	    // callback if ready
	    this.queue.forEach(function (q) {
	      utils.pushPath(q.loaded, [lng], ns);
	      remove(q.pending, name);
	
	      if (err) q.errors.push(err);
	
	      if (q.pending.length === 0 && !q.done) {
	        q.errors.length ? q.callback(q.errors) : q.callback();
	        _this3.emit('loaded', q.loaded);
	        q.done = true;
	      }
	    });
	
	    // remove done load requests
	    this.queue = this.queue.filter(function (q) {
	      return !q.done;
	    });
	  };
	
	  Connector.prototype.read = function read(lng, ns, fcName, tried, wait, callback) {
	    var _this4 = this;
	
	    if (!tried) tried = 0;
	    if (!wait) wait = 250;
	
	    if (!lng.length) return callback(null, {}); // noting to load
	
	    this.backend[fcName](lng, ns, function (err, data) {
	      if (err && data /* = retryFlag */ && tried < 5) {
	        setTimeout(function () {
	          _this4.read.call(_this4, lng, ns, fcName, ++tried, wait * 2, callback);
	        }, wait);
	        return;
	      }
	      callback(err, data);
	    });
	  };
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this5 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	      return callback && callback();
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    var toLoad = this.queueLoad(languages, namespaces, callback);
	    if (!toLoad.toLoad.length) {
	      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
	      return; // pendings will trigger callback
	    }
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this5.logger.log('loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);
	
	        toLoad.toLoad.forEach(function (name) {
	          var _name$split3 = name.split('|'),
	              _name$split4 = _slicedToArray(_name$split3, 2),
	              l = _name$split4[0],
	              n = _name$split4[1];
	
	          var bundle = utils.getPath(data, [l, n]);
	          if (bundle) {
	            _this5.loaded(name, err, bundle);
	          } else {
	            var _err = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	            _this5.loaded(name, _err);
	            _this5.logger.error(_err);
	          }
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this6 = this;
	
	            var _name$split5 = name.split('|'),
	                _name$split6 = _slicedToArray(_name$split5, 2),
	                lng = _name$split6[0],
	                ns = _name$split6[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this6.logger.warn('loading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this6.logger.log('loaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this6.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          toLoad.toLoad.forEach(function (name) {
	            readOne.call(_this5, name);
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.reload = function reload(languages, namespaces) {
	    var _this7 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this7.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this7.logger.log('reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);
	
	        languages.forEach(function (l) {
	          namespaces.forEach(function (n) {
	            var bundle = utils.getPath(data, [l, n]);
	            if (bundle) {
	              _this7.loaded(l + '|' + n, err, bundle);
	            } else {
	              var _err2 = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	              _this7.loaded(l + '|' + n, _err2);
	              _this7.logger.error(_err2);
	            }
	          });
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this8 = this;
	
	            var _name$split7 = name.split('|'),
	                _name$split8 = _slicedToArray(_name$split7, 2),
	                lng = _name$split8[0],
	                ns = _name$split8[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this8.logger.warn('reloading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this8.logger.log('reloaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this8.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          languages.forEach(function (l) {
	            namespaces.forEach(function (n) {
	              readOne.call(_this7, l + '|' + n);
	            });
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
	    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);
	
	    // write to store to avoid resending
	    if (!languages || !languages[0]) return;
	    this.store.addResource(languages[0], namespace, key, fallbackValue);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(10);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(7);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(8);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(cache, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.cache = cache;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('cacheConnector');
	
	    _this.cache && _this.cache.init && _this.cache.init(services, options.cache, options);
	    return _this;
	  }
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this2 = this;
	
	    if (!this.cache) return callback && callback();
	    var options = _extends({}, this.cache.options, this.options.cache);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    if (options.enabled) {
	      this.cache.load(languages, function (err, data) {
	        if (err) _this2.logger.error('loading languages ' + languages.join(', ') + ' from cache failed', err);
	        if (data) {
	          for (var l in data) {
	            for (var n in data[l]) {
	              if (n === 'i18nStamp') continue;
	              var bundle = data[l][n];
	              if (bundle) _this2.store.addResourceBundle(l, n, bundle);
	            }
	          }
	        }
	        if (callback) callback();
	      });
	    } else {
	      if (callback) callback();
	    }
	  };
	
	  Connector.prototype.save = function save() {
	    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.transformOptions = transformOptions;
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false, // string or array of namespaces
	
	    whitelist: false, // array with whitelisted languages
	    nonExplicitWhitelist: false,
	    load: 'all', // | currentOnly | languageOnly
	    preload: false, // array with preload languages
	
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	
	    saveMissing: false, // enable to send missing values
	    saveMissingTo: 'fallback', // 'current' || 'all'
	    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
	
	    postProcess: false, // string or array of postProcessor names
	    returnNull: true, // allows null value as valid translation
	    returnEmptyString: true, // allows empty string value as valid translation
	    returnObjects: false,
	    joinArrays: false, // or string to join array
	    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
	    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
	    appendNamespaceToMissingKey: false,
	    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
	      return { defaultValue: args[1] };
	    },
	
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      // prefixEscaped: '{{',
	      // suffixEscaped: '}}',
	      // unescapeSuffix: '',
	      unescapePrefix: '-',
	
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      // nestingPrefixEscaped: '$t(',
	      // nestingSuffixEscaped: ')',
	      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
	    }
	  };
	}
	
	function transformOptions(options) {
	  // create namespace object if namespace is passed in as string
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  // extend whitelist with cimode
	  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');
	
	  return options;
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (number) {
	  var rounded = isNaN(number) ? '0.00' : number.toFixed(2);
	
	  return {
	    priceInteger: rounded.split('.')[0],
	    priceFractional: rounded.split('.')[1]
	  };
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  text: _react.PropTypes.string.isRequired,
	  subText: _react.PropTypes.string
	};
	
	var Heading = function Heading(_ref) {
	  var text = _ref.text,
	      subText = _ref.subText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'heading' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      text
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      subText
	    )
	  );
	};
	
	Heading.propTypes = propTypes;
	exports.default = Heading;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Separator = function Separator() {
	  return _react2.default.createElement('div', { className: 'horizontal-separator' });
	};
	
	exports.default = Separator;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _PlanBox = __webpack_require__(30);
	
	var _PlanBox2 = _interopRequireDefault(_PlanBox);
	
	__webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  selectedPlanPeriod: _react.PropTypes.string,
	  selectPlanKey: _react.PropTypes.func,
	  plans: _react.PropTypes.array.isRequired,
	  currencySymbol: _react.PropTypes.string.isRequired
	};
	
	var BillingCycleSelection = function BillingCycleSelection(_ref) {
	  var selectedPlanPeriod = _ref.selectedPlanPeriod,
	      selectPlanKey = _ref.selectPlanKey,
	      plans = _ref.plans,
	      currencySymbol = _ref.currencySymbol;
	
	  var selectPlan = function selectPlan(period) {
	    var selectedPlan = plans.find(function (plan) {
	      return plan.period === period;
	    });
	    selectPlanKey(selectedPlan.key);
	  };
	
	  var annualPlan = plans.find(function (plan) {
	    return plan.period === 'YEAR';
	  });
	  var monthlyPlan = plans.find(function (plan) {
	    return plan.period === 'MONTH';
	  });
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'billing-cycle-selection' },
	    _react2.default.createElement(_PlanBox2.default, {
	      id: 'annual-box-label',
	      inputId: 'annual-box-radio',
	      title: _i18next2.default.t('Annual'),
	      currencySymbol: currencySymbol,
	      price: annualPlan.listPrice / 12,
	      timeSlot: _i18next2.default.t('per organizer, per month'),
	      description: '' + currencySymbol + annualPlan.listPrice + ' ' + _i18next2.default.t('billed annually'),
	      stickerAmount: '20',
	      checked: selectedPlanPeriod === 'YEAR',
	      onChange: function onChange() {
	        return selectPlan('YEAR');
	      }
	    }),
	    _react2.default.createElement(_PlanBox2.default, {
	      id: 'monthly-box-label',
	      inputId: 'monthly-box-radio',
	      title: _i18next2.default.t('Monthly'),
	      currencySymbol: currencySymbol,
	      price: monthlyPlan.listPrice,
	      timeSlot: _i18next2.default.t('per organizer, per month'),
	      checked: selectedPlanPeriod === 'MONTH',
	      onChange: function onChange() {
	        return selectPlan('MONTH');
	      }
	    })
	  );
	};
	
	BillingCycleSelection.propTypes = propTypes;
	exports.default = BillingCycleSelection;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _convertNumberToPrice = __webpack_require__(20);
	
	var _convertNumberToPrice2 = _interopRequireDefault(_convertNumberToPrice);
	
	var _TotalNumber = __webpack_require__(31);
	
	var _TotalNumber2 = _interopRequireDefault(_TotalNumber);
	
	var _PlanBoxSticker = __webpack_require__(34);
	
	var _PlanBoxSticker2 = _interopRequireDefault(_PlanBoxSticker);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  inputId: _react.PropTypes.string.isRequired,
	  checked: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func.isRequired,
	  title: _react.PropTypes.string,
	  currencySymbol: _react.PropTypes.string.isRequired,
	  price: _react.PropTypes.number.isRequired,
	  timeSlot: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  stickerAmount: _react.PropTypes.string
	};
	
	var defaultProps = {
	  id: ''
	};
	
	var PlanBox = function PlanBox(_ref) {
	  var id = _ref.id,
	      inputId = _ref.inputId,
	      title = _ref.title,
	      description = _ref.description,
	      currencySymbol = _ref.currencySymbol,
	      price = _ref.price,
	      timeSlot = _ref.timeSlot,
	      stickerAmount = _ref.stickerAmount,
	      checked = _ref.checked,
	      onChange = _ref.onChange;
	
	  var className = checked ? 'plan-box checked' : 'plan-box';
	
	  return _react2.default.createElement(
	    'label',
	    { id: id, htmlFor: inputId, className: className },
	    _react2.default.createElement(_PlanBoxSticker2.default, { stickerAmount: stickerAmount }),
	    _react2.default.createElement(
	      'span',
	      { className: 'title' },
	      title
	    ),
	    _react2.default.createElement(_TotalNumber2.default, {
	      currencySymbol: currencySymbol,
	      priceInteger: (0, _convertNumberToPrice2.default)(price).priceInteger,
	      priceFractional: (0, _convertNumberToPrice2.default)(price).priceFractional,
	      description: timeSlot
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    ),
	    _react2.default.createElement('input', {
	      type: 'radio',
	      id: inputId,
	      checked: checked,
	      onChange: onChange
	    })
	  );
	};
	
	PlanBox.propTypes = propTypes;
	PlanBox.defaultProps = defaultProps;
	exports.default = PlanBox;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  priceInteger: _react.PropTypes.string.isRequired,
	  priceFractional: _react.PropTypes.string,
	  currencySymbol: _react.PropTypes.string.isRequired,
	  description: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  id: _react.PropTypes.string
	};
	
	var TotalNumber = function TotalNumber(_ref) {
	  var id = _ref.id,
	      currencySymbol = _ref.currencySymbol,
	      description = _ref.description,
	      priceInteger = _ref.priceInteger,
	      priceFractional = _ref.priceFractional;
	
	  return _react2.default.createElement(
	    'span',
	    { id: id, className: 'total-number' },
	    _react2.default.createElement(
	      'span',
	      { className: 'symbol' },
	      currencySymbol
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'price-number' },
	      _react2.default.createElement(
	        'span',
	        { className: 'price-integer' },
	        priceInteger
	      ),
	      priceFractional ? _react2.default.createElement(
	        'span',
	        { className: 'decimal-point' },
	        '.'
	      ) : null,
	      _react2.default.createElement(
	        'span',
	        { className: 'price-fractional' },
	        priceFractional
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'time-slot' },
	      description
	    )
	  );
	};
	
	TotalNumber.propTypes = propTypes;
	exports.default = TotalNumber;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  stickerAmount: _react.PropTypes.string
	};
	
	var PlanBoxSticker = function PlanBoxSticker(_ref) {
	  var stickerAmount = _ref.stickerAmount;
	
	  if (stickerAmount) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-box-sticker ' + _i18next2.default.language },
	      _react2.default.createElement(
	        'span',
	        { className: 'text' },
	        _i18next2.default.t('Save %s%%', stickerAmount)
	      )
	    );
	  }
	  return null;
	};
	
	PlanBoxSticker.propTypes = propTypes;
	exports.default = PlanBoxSticker;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	__webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  text: _react.PropTypes.string.isRequired,
	  onClick: _react.PropTypes.func
	};
	
	var ChangePlan = function ChangePlan(_ref) {
	  var text = _ref.text,
	      onClick = _ref.onClick,
	      id = _ref.id;
	
	  return _react2.default.createElement(
	    'span',
	    { id: id, className: 'change-plan' },
	    _react2.default.createElement(
	      'span',
	      { className: 'plan-name togo-font-semibold' },
	      text
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        id: 'plan-form-change-plan-button',
	        className: 'btn btn-link',
	        onClick: onClick
	      },
	      _i18next2.default.t('Change plan')
	    )
	  );
	};
	
	ChangePlan.propTypes = propTypes;
	exports.default = ChangePlan;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _constructUrl = __webpack_require__(45);
	
	var _constructUrl2 = _interopRequireDefault(_constructUrl);
	
	__webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  commerceUrl: _react.PropTypes.string.isRequired,
	  productKey: _react.PropTypes.string.isRequired,
	  quantities: _react.PropTypes.number.isRequired,
	  planKeys: _react.PropTypes.number.isRequired,
	  catalogKey: _react.PropTypes.number.isRequired,
	  track: _react.PropTypes.func
	};
	
	var defaultProps = {
	  track: function track() {}
	};
	
	var Footer = function Footer(_ref) {
	  var commerceUrl = _ref.commerceUrl,
	      productKey = _ref.productKey,
	      quantities = _ref.quantities,
	      planKeys = _ref.planKeys,
	      catalogKey = _ref.catalogKey,
	      track = _ref.track;
	
	  var href = (0, _constructUrl2.default)(commerceUrl, { productKey: productKey, quantities: quantities, planKeys: planKeys, catalogKey: catalogKey });
	
	  var onClick = function onClick() {
	    var mixPanelData = {
	      planKey: planKeys,
	      Organizers: quantities
	    };
	    track('IPP: "Checkout" clicked', mixPanelData);
	    window.setTimeout(function () {
	      window.location.href = href;
	    }, 150);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'plan-form-footer' },
	    _react2.default.createElement(
	      'a',
	      {
	        id: 'plan-form-checkout-button',
	        className: 'btn btn-g2m',
	        disabled: !(quantities <= 39 && quantities >= 1),
	        href: href,
	        onClick: onClick
	      },
	      _i18next2.default.t('Checkout')
	    )
	  );
	};
	
	Footer.propTypes = propTypes;
	Footer.defaultProps = defaultProps;
	exports.default = Footer;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _url = __webpack_require__(46);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _querystring = __webpack_require__(50);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (baseUrl, queryParams) {
	  var parsedUrl = _url2.default.parse(baseUrl);
	  parsedUrl.search = '?' + _querystring2.default.stringify(queryParams);
	
	  return parsedUrl.format();
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(47);
	var util = __webpack_require__(49);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(50);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(51);
	exports.encode = exports.stringify = __webpack_require__(52);


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _react.PropTypes.string.isRequired,
	  children: _react.PropTypes.element.isRequired,
	  isPrimary: _react.PropTypes.bool
	};
	
	var FormField = function FormField(_ref) {
	  var label = _ref.label,
	      children = _ref.children,
	      isPrimary = _ref.isPrimary;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-field' },
	    _react2.default.createElement(
	      'label',
	      {
	        htmlFor: children.props.id,
	        className: isPrimary ? 'primary form-field-label' : 'form-field-label'
	      },
	      label
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'children' },
	      children
	    )
	  );
	};
	
	FormField.propTypes = propTypes;
	exports.default = FormField;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _react.PropTypes.string.isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	
	var FormRadioField = function FormRadioField(_ref) {
	  var label = _ref.label,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'fieldset',
	    { className: 'form-radio-field' },
	    _react2.default.createElement(
	      'h4',
	      { className: 'form-field-heading' },
	      label
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'children' },
	      children
	    )
	  );
	};
	
	FormRadioField.propTypes = propTypes;
	exports.default = FormRadioField;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string,
	  onChange: _react.PropTypes.func.isRequired,
	  value: _react.PropTypes.number.isRequired,
	  min: _react.PropTypes.string.isRequired,
	  description: _react.PropTypes.string
	};
	
	var NumberInput = function NumberInput(_ref) {
	  var id = _ref.id,
	      value = _ref.value,
	      min = _ref.min,
	      description = _ref.description,
	      _onChange = _ref.onChange;
	
	  var increment = function increment() {
	    if (value) {
	      _onChange(value + 1);
	    } else {
	      _onChange(1);
	    }
	  };
	
	  var decrement = function decrement() {
	    if (value && value > min) {
	      _onChange(value - 1);
	    } else {
	      _onChange(1);
	    }
	  };
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'number-input' },
	    _react2.default.createElement(
	      'button',
	      { id: 'decrement-price-button', onClick: decrement },
	      _react2.default.createElement('i', { className: 'fa fa-minus-circle', 'aria-hidden': 'true' })
	    ),
	    _react2.default.createElement('input', {
	      id: id,
	      type: 'number',
	      min: min,
	      value: value,
	      onChange: function onChange(event) {
	        return _onChange(parseInt(event.target.value, 10));
	      }
	    }),
	    _react2.default.createElement(
	      'button',
	      { id: 'increment-price-button', onClick: increment },
	      _react2.default.createElement('i', { className: 'fa fa-plus-circle', 'aria-hidden': 'true' })
	    ),
	    description && _react2.default.createElement(
	      'div',
	      { className: 'description' },
	      description
	    )
	  );
	};
	
	NumberInput.propTypes = propTypes;
	exports.default = NumberInput;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _TotalNumber = __webpack_require__(31);
	
	var _TotalNumber2 = _interopRequireDefault(_TotalNumber);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  organizerCount: _react.PropTypes.number
	};
	
	var TotalPrice = function TotalPrice(props) {
	  var selectComponent = function selectComponent() {
	    if (props.organizerCount > 39) {
	      var salesUrl = 'https://www.gotomeeting.com/contact-sales';
	
	      var dangerousHtml = {
	        __html: _i18next2.default.t('For more than 39 organizers, %scontact our sales team%s', '<a href="' + salesUrl + '">', '</a>')
	      };
	
	      return _react2.default.createElement('span', {
	        id: props.id,
	        className: 'contact-sales-text',
	        dangerouslySetInnerHTML: dangerousHtml // eslint-disable-line react/no-danger
	      });
	    }
	
	    return _react2.default.createElement(_TotalNumber2.default, props);
	  };
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'total-price' },
	    selectComponent()
	  );
	};
	
	TotalPrice.propTypes = propTypes;
	exports.default = TotalPrice;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var Close = function Close(_ref) {
	  var onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      id: 'close-product-purchase',
	      className: 'btn btn-link close',
	      onClick: onClick
	    },
	    _react2.default.createElement('i', { className: 'togo-icon togo-icon-closes' })
	  );
	};
	
	Close.propTypes = propTypes;
	
	exports.default = Close;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _Heading = __webpack_require__(21);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _PlanInformationContainer = __webpack_require__(73);
	
	var _PlanInformationContainer2 = _interopRequireDefault(_PlanInformationContainer);
	
	__webpack_require__(89);
	
	var _Close = __webpack_require__(69);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  changePage: _react.PropTypes.func.isRequired,
	  changeBundle: _react.PropTypes.func.isRequired,
	  bundles: _react.PropTypes.array.isRequired,
	  close: _react.PropTypes.func.isRequired
	};
	
	var defaultProps = {
	  changePage: function changePage() {},
	  changeBundle: function changeBundle() {},
	  bundles: []
	};
	
	var PlanSelection = function PlanSelection(_ref) {
	  var changePage = _ref.changePage,
	      changeBundle = _ref.changeBundle,
	      bundles = _ref.bundles,
	      close = _ref.close;
	
	  var selectBundle = function selectBundle(bundleIndex) {
	    changeBundle(bundleIndex);
	    changePage('plan-form', { bundleKey: bundles[bundleIndex].key });
	  };
	
	  var renderPlans = function renderPlans() {
	    return bundles.map(function (bundle, index) {
	      var isPrimaryPlan = bundles[index].isPrimaryPlan;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'plan-container',
	          key: index
	        },
	        _react2.default.createElement(_PlanInformationContainer2.default, {
	          bundle: bundles[index],
	          isPrimaryPlan: isPrimaryPlan
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'plan-select-button-container' },
	          _react2.default.createElement(
	            'button',
	            {
	              id: 'select-plan-button-' + index,
	              className: 'btn btn-default plan-select-button',
	              onClick: function onClick() {
	                return selectBundle(index);
	              }
	            },
	            _i18next2.default.t('Select')
	          )
	        )
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'plan-selection' },
	    _react2.default.createElement(_Close2.default, { onClick: close }),
	    _react2.default.createElement(_Heading2.default, { text: _i18next2.default.t('Choose your plan') }),
	    renderPlans()
	  );
	};
	
	PlanSelection.propTypes = propTypes;
	PlanSelection.defaultProps = defaultProps;
	exports.default = PlanSelection;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _PlanName = __webpack_require__(74);
	
	var _PlanName2 = _interopRequireDefault(_PlanName);
	
	var _PlanAttendees = __webpack_require__(77);
	
	var _PlanAttendees2 = _interopRequireDefault(_PlanAttendees);
	
	var _PlanFeatures = __webpack_require__(80);
	
	var _PlanFeatures2 = _interopRequireDefault(_PlanFeatures);
	
	var _Separator = __webpack_require__(26);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _TotalNumber = __webpack_require__(31);
	
	var _TotalNumber2 = _interopRequireDefault(_TotalNumber);
	
	__webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  bundle: _react.PropTypes.object.isRequired,
	  isPrimaryPlan: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  bundle: {},
	  isPrimaryPlan: false
	};
	
	var PlanInformationContainer = function PlanInformationContainer(_ref) {
	  var bundle = _ref.bundle,
	      isPrimaryPlan = _ref.isPrimaryPlan;
	
	  var renderPrimaryPlanHeading = function renderPrimaryPlanHeading() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', { className: 'primary-plan-top-highlighter' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'primary-plan-heading' },
	        _i18next2.default.t('CURRENT PLAN')
	      )
	    );
	  };
	
	  var renderPlanName = function renderPlanName(displayName) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-name-container' },
	      _react2.default.createElement(_PlanName2.default, { name: displayName })
	    );
	  };
	
	  var renderPlanAttendeesInformation = function renderPlanAttendeesInformation(maxattendees) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-attendees-container' },
	      _react2.default.createElement(_PlanAttendees2.default, { maxAttendees: maxattendees })
	    );
	  };
	
	  var renderFirstSeparator = function renderFirstSeparator() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'first-separator-container' },
	      _react2.default.createElement(_Separator2.default, null)
	    );
	  };
	
	  var renderPrice = function renderPrice(price, currencySymbol, id) {
	    var descriptionElement = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        _i18next2.default.t('per organizer, per month')
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        _i18next2.default.t('billed annually')
	      )
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-price-container' },
	      _react2.default.createElement(_TotalNumber2.default, {
	        priceInteger: price.toString(),
	        currencySymbol: currencySymbol,
	        description: descriptionElement,
	        id: id
	      })
	    );
	  };
	
	  var renderSecondSeparator = function renderSecondSeparator() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'second-separator-container' },
	      _react2.default.createElement(_Separator2.default, null)
	    );
	  };
	
	  var renderPlanFeatures = function renderPlanFeatures(planName) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'plan-features-container' },
	      _react2.default.createElement(_PlanFeatures2.default, { planName: planName })
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'plan-information-container' },
	    isPrimaryPlan ? renderPrimaryPlanHeading() : null,
	    renderPlanName(bundle.displayName),
	    renderPlanAttendeesInformation(bundle.plans[0].billableFeatures.maxattendees),
	    renderFirstSeparator(),
	    renderPrice(bundle.plans[0].listPrice, bundle.currencySymbol, bundle.displayName + 'price'),
	    renderSecondSeparator(),
	    renderPlanFeatures(bundle.plans[0].name)
	  );
	};
	
	PlanInformationContainer.propTypes = propTypes;
	PlanInformationContainer.defaultProps = defaultProps;
	exports.default = PlanInformationContainer;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  name: _react.PropTypes.string.isRequired
	};
	
	var PlanName = function PlanName(_ref) {
	  var name = _ref.name;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'plan-name' },
	    name
	  );
	};
	
	PlanName.propTypes = propTypes;
	exports.default = PlanName;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	__webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  maxAttendees: _react.PropTypes.number.isRequired
	};
	
	var PlanAttendees = function PlanAttendees(_ref) {
	  var maxAttendees = _ref.maxAttendees;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'plan-attendees' },
	    _i18next2.default.t('Up to %s Attendees', maxAttendees)
	  );
	};
	
	PlanAttendees.propTypes = propTypes;
	exports.default = PlanAttendees;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _planFeatures = __webpack_require__(81);
	
	var _planFeatures2 = _interopRequireDefault(_planFeatures);
	
	var _Feature = __webpack_require__(82);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	__webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  planName: _react.PropTypes.string.isRequired
	};
	
	var renderFeatures = function renderFeatures(features) {
	  return features.map(function (feature, index) {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'feature-container',
	        key: index
	      },
	      _react2.default.createElement(_Feature2.default, {
	        featureName: _i18next2.default.t(feature.name),
	        isAvailable: feature.available
	      })
	    );
	  });
	};
	
	var PlanFeatures = function PlanFeatures(_ref) {
	  var planName = _ref.planName;
	
	  var features = (0, _planFeatures2.default)(planName);
	  return _react2.default.createElement(
	    'div',
	    null,
	    renderFeatures(features)
	  );
	};
	
	PlanFeatures.propTypes = propTypes;
	exports.default = PlanFeatures;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var planFeatures = {
	  G2M_Starter3: [{ name: 'Web audio and dial-in', available: true }, { name: 'Screen sharing', available: true }, { name: 'HD video conferencing', available: true }, { name: 'Drawing tools', available: false }, { name: 'Recording', available: false }, { name: 'Personal meeting room', available: false }, { name: 'Mobile apps', available: false }, { name: 'Keyboard & mouse sharing', available: false }, { name: 'Active directory', available: false }, { name: 'Virtual whiteboard', available: false }],
	  G2M_Pro2: [{ name: 'Web audio and dial-in', available: true }, { name: 'Screen sharing', available: true }, { name: 'HD video conferencing', available: true }, { name: 'Drawing tools', available: true }, { name: 'Recording', available: true }, { name: 'Personal meeting room', available: true }, { name: 'Mobile apps', available: true }, { name: 'Keyboard & mouse sharing', available: true }, { name: 'Active directory', available: false }, { name: 'Virtual whiteboard', available: false }],
	  G2M_Plus2: [{ name: 'Web audio and dial-in', available: true }, { name: 'Screen sharing', available: true }, { name: 'HD video conferencing', available: true }, { name: 'Drawing tools', available: true }, { name: 'Recording', available: true }, { name: 'Personal meeting room', available: true }, { name: 'Mobile apps', available: true }, { name: 'Keyboard & mouse sharing', available: true }, { name: 'Active directory', available: true }, { name: 'Virtual whiteboard', available: true }]
	};
	
	exports.default = function (planName) {
	  return planFeatures[planName];
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  featureName: _react.PropTypes.string.isRequired,
	  isAvailable: _react.PropTypes.bool
	};
	
	var Feature = function Feature(_ref) {
	  var featureName = _ref.featureName,
	      isAvailable = _ref.isAvailable;
	
	  return _react2.default.createElement(
	    'div',
	    { className: isAvailable ? 'feature' : 'feature unavailable' },
	    _react2.default.createElement(
	      'div',
	      { className: 'checkmark-container' },
	      _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-container' },
	      featureName
	    )
	  );
	};
	
	Feature.propTypes = propTypes;
	exports.default = Feature;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DescriptionLeft = __webpack_require__(92);
	
	var _DescriptionLeft2 = _interopRequireDefault(_DescriptionLeft);
	
	var _DescriptionRight = __webpack_require__(93);
	
	var _DescriptionRight2 = _interopRequireDefault(_DescriptionRight);
	
	var _Footer = __webpack_require__(94);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(95);
	
	var _Close = __webpack_require__(69);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isAccountAdmin: _react.PropTypes.bool.isRequired,
	  trialDaysLeft: _react.PropTypes.number.isRequired,
	  changePage: _react.PropTypes.func.isRequired,
	  close: _react.PropTypes.func.isRequired,
	  track: _react.PropTypes.func,
	  isRedirectCommerce: _react.PropTypes.bool,
	  commerceUrl: _react.PropTypes.string,
	  productKey: _react.PropTypes.string
	};
	
	var G2MTrialPromo = function G2MTrialPromo(_ref) {
	  var isAccountAdmin = _ref.isAccountAdmin,
	      trialDaysLeft = _ref.trialDaysLeft,
	      changePage = _ref.changePage,
	      close = _ref.close,
	      track = _ref.track,
	      isRedirectCommerce = _ref.isRedirectCommerce,
	      commerceUrl = _ref.commerceUrl,
	      productKey = _ref.productKey;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'g2m-trial-promo' },
	    _react2.default.createElement(_Close2.default, { onClick: close }),
	    _react2.default.createElement(
	      'div',
	      { className: 'main-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content-left' },
	        _react2.default.createElement(_DescriptionLeft2.default, { isAccountAdmin: isAccountAdmin, trialDaysLeft: trialDaysLeft })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'main-content-right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-content-right-wrapper' },
	          _react2.default.createElement(_DescriptionRight2.default, null),
	          _react2.default.createElement(_Footer2.default, {
	            isAccountAdmin: isAccountAdmin,
	            close: close,
	            isRedirectCommerce: isRedirectCommerce,
	            commerceUrl: commerceUrl,
	            productKey: productKey,
	            changePage: changePage,
	            trialDaysLeft: trialDaysLeft,
	            track: track
	          })
	        )
	      )
	    )
	  );
	};
	
	G2MTrialPromo.propTypes = propTypes;
	
	exports.default = G2MTrialPromo;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  trialDaysLeft: _react.PropTypes.number.isRequired,
	  isAccountAdmin: _react.PropTypes.bool.isRequired
	};
	
	var DescriptionLeft = function DescriptionLeft(_ref) {
	  var isAccountAdmin = _ref.isAccountAdmin,
	      trialDaysLeft = _ref.trialDaysLeft;
	
	  var generateHeadingText = function generateHeadingText() {
	    switch (trialDaysLeft) {
	      case 0:
	        return _i18next2.default.t('Your GoToMeeting Pro trial has ended...');
	      case 1:
	        return _i18next2.default.t('Your GoToMeeting Pro trial ends in 1 day...');
	      default:
	        return _i18next2.default.t('Your GoToMeeting Pro trial ends in %s days...', trialDaysLeft);
	    }
	  };
	  var generateDescriptionText = function generateDescriptionText() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        _i18next2.default.t('That means you\'re missing out on what GoToMeeting can offer, including ')
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          _i18next2.default.t('unlimited meetings with up to 150 participants')
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _i18next2.default.t(', powerful mobile apps and a whole lot more.')
	      )
	    );
	  };
	
	  var renderFeatures = function renderFeatures() {
	    return _react2.default.createElement(
	      'ul',
	      { className: 'togo-font-light description-left-features' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' }),
	        _i18next2.default.t('Unlimited recording')
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' }),
	        _i18next2.default.t('Personal meeting room')
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' }),
	        _i18next2.default.t('Dial-in phone numbers')
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' }),
	        _i18next2.default.t('HD video support for 25 webcams')
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-check' }),
	        _i18next2.default.t('Meeting transcriptions')
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'description-left-wrapper' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'description-left-heading' },
	      generateHeadingText()
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'togo-font-light description-left' },
	      generateDescriptionText()
	    ),
	    _react2.default.createElement(
	      'h4',
	      { className: 'description-left-features-heading' },
	      _i18next2.default.t('Don\'t lose access to these features')
	    ),
	    renderFeatures()
	  );
	};
	
	DescriptionLeft.propTypes = propTypes;
	exports.default = DescriptionLeft;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionRight = function DescriptionRight() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'description-right-offer-wrapper' },
	    _react2.default.createElement(
	      'p',
	      { className: 'description-right-offer-save-up-to' },
	      _i18next2.default.t('SAVE UP TO')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'description-right-offer-20-percent-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'description-right-offer-vertical-line' },
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'description-right-offer-20-percent' },
	        _i18next2.default.t('20%')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'description-right-offer-vertical-line' },
	        '\xA0'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'description-right-offer-off' },
	      _i18next2.default.t('OFF')
	    ),
	    _react2.default.createElement(
	      'h4',
	      { className: 'description-right-sign-up' },
	      _i18next2.default.t('Sign up for an annual plan today and save!')
	    )
	  );
	};
	
	exports.default = DescriptionRight;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _constructUrl = __webpack_require__(45);
	
	var _constructUrl2 = _interopRequireDefault(_constructUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isAccountAdmin: _react.PropTypes.bool.isRequired,
	  close: _react.PropTypes.func.isRequired,
	  isRedirectCommerce: _react.PropTypes.bool,
	  commerceUrl: _react.PropTypes.string,
	  productKey: _react.PropTypes.string,
	  changePage: _react.PropTypes.func.isRequired,
	  trialDaysLeft: _react.PropTypes.number,
	  track: _react.PropTypes.func
	};
	
	var defaultProps = {
	  track: function track() {}
	};
	
	var Footer = function Footer(_ref) {
	  var isAccountAdmin = _ref.isAccountAdmin,
	      close = _ref.close,
	      isRedirectCommerce = _ref.isRedirectCommerce,
	      commerceUrl = _ref.commerceUrl,
	      productKey = _ref.productKey,
	      track = _ref.track,
	      changePage = _ref.changePage,
	      trialDaysLeft = _ref.trialDaysLeft;
	
	  var text = isAccountAdmin ? _i18next2.default.t('Buy Now') : _i18next2.default.t('Got it');
	  var href = isRedirectCommerce ? (0, _constructUrl2.default)(commerceUrl, { productKey: productKey }) : '';
	
	  var trackAction = function trackAction() {
	    if (trialDaysLeft) {
	      track('Marvel expiring trial: Subscribe');
	    } else {
	      track('Expired trial modal: Subscribe');
	    }
	  };
	
	  var onClick = function onClick(event) {
	    if (isRedirectCommerce) {
	      trackAction();
	      window.setTimeout(function () {
	        return window.location.assign(href);
	      }, 700);
	    } else if (isAccountAdmin) {
	      changePage('plan-form');
	      trackAction();
	    } else {
	      close(event);
	    }
	
	    event.preventDefault();
	  };
	
	  return _react2.default.createElement(
	    'a',
	    {
	      id: 'g2m-trial-promo-next-button',
	      className: 'btn btn-g2m',
	      onClick: onClick,
	      href: href
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      text
	    )
	  );
	};
	
	Footer.propTypes = propTypes;
	Footer.defaultProps = defaultProps;
	exports.default = Footer;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "de": { "translation": { "Your GoToMeeting Pro trial has ended...": "Ihre Testversion von GoToMeeting Pro ist abgelaufen...", "Your GoToMeeting Pro trial ends in 1 day...": "Ihre Testversion von GoToMeeting Pro läuft in 1 Tag ab...", "Your GoToMeeting Pro trial ends in %s days...": "Ihre Testversion von GoToMeeting Pro läuft in %s Tagen ab...", "That means you're missing out on what GoToMeeting can offer, including ": "Das bedeutet, dass Sie nun nicht mehr von all den großartigen GoToMeeting-Funktionen Gebrauch machen können, darunter ", "unlimited meetings with up to 150 participants": "unbegrenzte Meetings mit bis zu 150 Teilnehmern", ", powerful mobile apps and a whole lot more.": ", leistungsstarke mobile Apps und vieles mehr.", "Don't lose access to these features": "Lassen Sie sich diese Funktionen nicht entgehen:", "Unlimited recording": "Unbegrenzte Aufzeichnungen", "Personal meeting room": "Persönlicher Meeting-Raum", "Dial-in phone numbers": "Rufnummern für die telefonische Einwahl", "HD video support for 25 webcams": "HD-Videoübertragung von 25 Webcams", "Meeting transcriptions": "Meeting-Transkription", "SAVE UP TO": "BIS ZU", "20%": "20%", "OFF": "SPAREN", "Sign up for an annual plan today and save!": "Entscheiden Sie sich jetzt für ein Jahresabo und sparen Sie bares Geld!", "Unlimited phone audio": "Unbegrenztes Telefonaudio", "Desktop and mobile apps": "Desktop-Apps und mobile Apps", "Buy Now": "Jetzt kaufen", "Got it": "Alles klar!", "Web audio and dial-in": "Internetaudio und Einwahl per Telefon", "Screen sharing": "Bildschirmübertragung", "HD video conferencing": "HD-Videokonferenzen", "Drawing tools": "Zeichenwerkzeuge", "Recording": "Aufzeichnung", "Mobile apps": "Mobile Apps", "Keyboard & mouse sharing": "Gemeinsame Verwendung von Tastatur und Maus", "Active directory": "Active Directory", "Virtual whiteboard": "Virtuelles Whiteboard", "Choose your plan": "Wählen Sie Ihr Abo aus", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "AKTUELLES ABONNEMENT", "Up to %s Attendees": "Bis zu %s Teilnehmer", "per organizer, per month": "pro Organisator, pro Monat", "billed annually": "jährliche Abrechnung", "Select": "Auswählen", "Almost there!": "Überprüfung und Bestätigung", "Choose your billing cycle and number of organizers": "Wählen Sie Ihren Abrechnungszyklus und die Anzahl der Organisatoren", "Plan": "Abo", "Billing Cycle": "Abrechnungszeitraum", "No. of Organizers": "Anzahl Organisatoren", "My Total": "Gesamtbetrag", "Change plan": "Abo ändern", "Annual": "Jahresabo", "Monthly": "Monatsabo", "%s billed annually": "%s jährliche Abrechnung", "Save %s%%": "%s%% Nachlass", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Fügen Sie weitere Organisatoren hinzu, wenn mehr als 1 Person Ihres Teams eigene Meetings planen und starten dürfen soll.", "for 1 year": "für 1 Jahr", "for 1 month": "für 1 Monat", "Checkout": "Bezahlen", "For more than 39 organizers, %scontact our sales team%s": "39 oder mehr Organisatoren: %sWenden Sie sich an unser Vertriebsteam%s" } }, "en": { "translation": { "Your GoToMeeting Pro trial has ended...": "Your GoToMeeting Pro trial has ended...", "Your GoToMeeting Pro trial ends in 1 day...": "Your GoToMeeting Pro trial ends in 1 day...", "Your GoToMeeting Pro trial ends in %s days...": "Your GoToMeeting Pro trial ends in %s days...", "That means you're missing out on what GoToMeeting can offer, including ": "That means you're missing out on what GoToMeeting can offer, including ", "unlimited meetings with up to 150 participants": "unlimited meetings with up to 150 participants", ", powerful mobile apps and a whole lot more.": ", powerful mobile apps and a whole lot more.", "Don't lose access to these features": "Don't lose access to these features:", "Unlimited recording": "Unlimited recording", "Personal meeting room": "Personal meeting room", "Dial-in phone numbers": "Dial-in phone numbers", "HD video support for 25 webcams": "HD video support for 25 webcams", "Meeting transcriptions": "Meeting transcriptions", "SAVE UP TO": "SAVE UP TO", "20%": "20%", "OFF": "OFF", "Sign up for an annual plan today and save!": "Sign up for an annual plan today and save!", "Unlimited phone audio": "Unlimited phone audio", "Desktop and mobile apps": "Desktop and mobile apps", "Buy Now": "Buy Now", "Got it": "Got it", "Web audio and dial-in": "Web audio and dial-in", "Screen sharing": "Screen sharing", "HD video conferencing": "HD video conferencing", "Drawing tools": "Drawing tools", "Recording": "Recording", "Mobile apps": "Mobile apps", "Keyboard & mouse sharing": "Keyboard & mouse sharing", "Active directory": "Active directory", "Virtual whiteboard": "Virtual whiteboard", "Choose your plan": "Choose your plan", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "CURRENT PLAN", "Up to %s Attendees": "Up to %s Attendees", "per organizer, per month": "per organizer, per month", "billed annually": "billed annually", "Select": "Select", "Almost there!": "Almost there!", "Choose your billing cycle and number of organizers": "Choose your billing cycle and number of organizers", "Plan": "Plan", "Billing Cycle": "Billing Cycle", "No. of Organizers": "No. of Organizers", "My Total": "My Total", "Change plan": "Change plan", "Annual": "Annual", "Monthly": "Monthly", "%s billed annually": "%s billed annually", "Save %s%%": "Save %s%%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.", "for 1 year": "for 1 year", "for 1 month": "for 1 month", "Checkout": "Checkout", "For more than 39 organizers, %scontact our sales team%s": "For more than 39 organizers, %scontact our sales team%s" } }, "es": { "translation": { "Your GoToMeeting Pro trial has ended...": "Su periodo de prueba de GoToMeeting Pro ha finalizado...", "Your GoToMeeting Pro trial ends in 1 day...": "Su periodo de prueba de GoToMeeting Pro finaliza en 1 dia...", "Your GoToMeeting Pro trial ends in %s days...": "Su periodo de prueba de GoToMeeting Pro finaliza en %s dias...", "That means you're missing out on what GoToMeeting can offer, including ": "Esto significa que se está perdiendo todo lo que GoToMeeting puede ofrecerle, como ", "unlimited meetings with up to 150 participants": "reuniones ilimitadas hasta con 150 participantes", ", powerful mobile apps and a whole lot more.": ", potentes aplicaciones para dispositivos móviles y mucho más.", "Don't lose access to these features": "No pierda el acceso a estas funciones:", "Unlimited recording": "Grabaciones ilimitadas", "Personal meeting room": "Sala de reuniones personal", "Dial-in phone numbers": "Números de acceso telefónico", "HD video support for 25 webcams": "Compatibilidad con vídeo HD para 25 webcams", "Meeting transcriptions": "Transcripciones de las reuniones", "SAVE UP TO": "AHORRE HASTA UN", "20%": "20%", "OFF": "", "Sign up for an annual plan today and save!": "¡Contrate hoy un plan anual y ahorre!", "Unlimited phone audio": "Audio telefónico ilimitado", "Desktop and mobile apps": "Aplicaciones de escritorio y para dispositivos móviles", "Buy Now": "Comprar ya", "Got it": "Entendido", "Web audio and dial-in": "Audio web y acceso telefónico", "Screen sharing": "Pantalla compartida", "HD video conferencing": "Conferencias de vídeo en alta definición", "Drawing tools": "Herramientas de dibujo", "Recording": "Grabaciones", "Mobile apps": "Aplicaciones móviles", "Keyboard & mouse sharing": "Teclado y cursor compartidos", "Active directory": "Active Directory", "Virtual whiteboard": "Pizarra virtual", "Choose your plan": "Elija su plan", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "PLAN ACTUAL", "Up to %s Attendees": "Hasta %s asistentes", "per organizer, per month": "al mes por organizador", "billed annually": "de facturación anual", "Select": "Seleccionar", "Almost there!": "Revisión y confirmación", "Choose your billing cycle and number of organizers": "Elija su ciclo de facturación y la cantidad de organizadores", "Plan": "Plan", "Billing Cycle": "Ciclo de facturación", "No. of Organizers": "Organizadores", "My Total": "Total", "Change plan": "Cambiar plan", "Annual": "Anual", "Monthly": "Mensual", "%s billed annually": "%s de facturación anual", "Save %s%%": "-%s %%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Añada organizadores si más de 1 persona de su equipo va a programar y organizar sus propias reuniones.", "for 1 year": "por 1 año", "for 1 month": "por 1 mes", "Checkout": "Finalizar", "For more than 39 organizers, %scontact our sales team%s": "Para planes con más de 39 organizadores, %spóngase en contacto con nuestro equipo de ventas%s." } }, "fr": { "translation": { "Your GoToMeeting Pro trial has ended...": "Votre essai de GoToMeeting Pro a pris fin...", "Your GoToMeeting Pro trial ends in 1 day...": "Votre essai de GoToMeeting Pro prend fin dans 1 jour...", "Your GoToMeeting Pro trial ends in %s days...": "Votre essai de GoToMeeting Pro prend fin dans %s jours...", "That means you're missing out on what GoToMeeting can offer, including ": "Cela signifie que vous ne pouvez plus accéder à tous les atouts de GoToMeeting, comme ", "unlimited meetings with up to 150 participants": "les réunions en illimité avec jusqu'à 150 personnes", ", powerful mobile apps and a whole lot more.": ", les apps mobiles et bien plus encore.", "Don't lose access to these features": "Ne perdez pas l'accès à ces fonctionnalités :", "Unlimited recording": "Enregistrement en illimité", "Personal meeting room": "Espace de réunion personnel", "Dial-in phone numbers": "Numéros de téléphone à appeler", "HD video support for 25 webcams": "Vidéo HD pour jusqu'à 25 webcams", "Meeting transcriptions": "Transcription de réunions", "SAVE UP TO": "JUSQU'À", "20%": "20%", "OFF": "DE REMISE", "Sign up for an annual plan today and save!": "Souscrivez un forfait annuel aujourd'hui et économisez !", "Unlimited phone audio": "Audio du téléphone illimité", "Desktop and mobile apps": "Applications mobile et de bureau", "Buy Now": "Acheter maintenant", "Got it": "OK", "Web audio and dial-in": "Appel et audio Web", "Screen sharing": "Partage d'écran", "HD video conferencing": "Visioconférence HD", "Drawing tools": "Outils de dessin", "Recording": "Enregistrement", "Mobile apps": "Applications mobiles", "Keyboard & mouse sharing": "Partage clavier et souris", "Active directory": "Active Directory", "Virtual whiteboard": "Tableau blanc virtuel", "Choose your plan": "Choisir un abonnement", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "ABONNEMENT EN COURS", "Up to %s Attendees": "Jusqu''à %s participants", "per organizer, per month": "par organisateur, par mois", "billed annually": "facturés annuellement", "Select": "Sélectionner", "Almost there!": "Vérifier et confirmer", "Choose your billing cycle and number of organizers": "Choisissez votre cycle de facturation et le nombre d'organisateurs", "Plan": "Abonnement", "Billing Cycle": "Cycle de facturation", "No. of Organizers": "Nombre d'organisateurs", "My Total": "Total", "Change plan": "Changer d'abonnement", "Annual": "Annuel", "Monthly": "Mensuel", "%s billed annually": "Facture annuelle de %s", "Save %s%%": "Économisez %s%%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Ajoutez des organisateurs si plusieurs personnes de votre équipe planifient et organisent leurs propres réunions.", "for 1 year": "pour 1 an", "for 1 month": "pendant 1 mois", "Checkout": "Paiement", "For more than 39 organizers, %scontact our sales team%s": "Pour plus de 39 organisateurs, %scontactez notre équipe commerciale%s" } }, "it": { "translation": { "Your GoToMeeting Pro trial has ended...": "La tua prova di GoToMeeting Pro è terminata...", "Your GoToMeeting Pro trial ends in 1 day...": "La tua prova di GoToMeeting Pro terminerà tra 1 giorno...", "Your GoToMeeting Pro trial ends in %s days...": "La tua prova di GoToMeeting Pro terminerà tra %s giorni...", "That means you're missing out on what GoToMeeting can offer, including ": "Ciò significa che non potrai più contare su tutto quello che ti può offrire GoToMeeting, inclusi ", "unlimited meetings with up to 150 participants": "meeting illimitati con fino a 150 partecipanti", ", powerful mobile apps and a whole lot more.": ", potenti app mobili e molto altro ancora.", "Don't lose access to these features": "Non perdere l'accesso a queste funzioni:", "Unlimited recording": "Registrazione illimitata", "Personal meeting room": "Sala riunioni personale", "Dial-in phone numbers": "Numeri telefonici da comporre", "HD video support for 25 webcams": "Supporto video HD per 25 webcam", "Meeting transcriptions": "Trascrizioni dei meeting", "SAVE UP TO": "RISPARMIA FINO AL", "20%": "20%", "OFF": "", "Sign up for an annual plan today and save!": "Registrati oggi per un piano annuale e risparmia!", "Unlimited phone audio": "Audio telefonico illimitato", "Desktop and mobile apps": "App desktop e mobili", "Buy Now": "Acquista ora", "Got it": "OK", "Web audio and dial-in": "Audio Web e chiamate", "Screen sharing": "Condivisione dello schermo", "HD video conferencing": "Videoconferenze HD", "Drawing tools": "Strumenti di disegno", "Recording": "Registrazione", "Mobile apps": "App mobili", "Keyboard & mouse sharing": "Condivisione della tastiera e del mouse", "Active directory": "Active Directory", "Virtual whiteboard": "Lavagna virtuale", "Choose your plan": "Seleziona il piano", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "PIANO ATTUALE", "Up to %s Attendees": "Fino a %s partecipanti", "per organizer, per month": "per organizzatore, al mese", "billed annually": "fatturati annualmente", "Select": "Seleziona", "Almost there!": "Rivedi e conferma", "Choose your billing cycle and number of organizers": "Scegli il ciclo di fatturazione e il numero di organizzatori", "Plan": "Piano", "Billing Cycle": "Ciclo di fatturazione", "No. of Organizers": "Numero di organizzatori", "My Total": "Totale", "Change plan": "Cambia piano", "Annual": "Annuale", "Monthly": "Mensile", "%s billed annually": "%s fatturati annualmente", "Save %s%%": "Risparmia %s%%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Aggiungi ulteriori organizzatori se più persone del team pianificheranno e organizzeranno riunioni.", "for 1 year": "per 1 anno", "for 1 month": "per 1 mese", "Checkout": "Completa transazione", "For more than 39 organizers, %scontact our sales team%s": "Per ottenere più di 39 organizzatori, %scontatta il team di vendite%s" } }, "pt": { "translation": { "Your GoToMeeting Pro trial has ended...": "Sua avaliação do GoToMeeting Pro terminou...", "Your GoToMeeting Pro trial ends in 1 day...": "Sua avaliação do GoToMeeting Pro termina em um dia...", "Your GoToMeeting Pro trial ends in %s days...": "Sua avaliação do GoToMeeting Pro termina em %s dias...", "That means you're missing out on what GoToMeeting can offer, including ": "Isso significa que você está perdendo o GoToMeeting pode oferecer, incluindo ", "unlimited meetings with up to 150 participants": "reuniões ilimitadas com até 150 participantes", ", powerful mobile apps and a whole lot more.": ", aplicativos móveis poderosos e muito mais.", "Don't lose access to these features": "Não perca o acesso a esses recursos:", "Unlimited recording": "Gravações ilimitadas", "Personal meeting room": "Sala pessoal de reuniões", "Dial-in phone numbers": "Números de telefone para chamar", "HD video support for 25 webcams": "Suporte de vídeo HD para 23 webcams", "Meeting transcriptions": "Transcrições de reunião", "SAVE UP TO": "ECONOMIZE ATÉ", "20%": "20%", "OFF": "DESATIVADO", "Sign up for an annual plan today and save!": "Registre-se hoje para um plano ano e economize!", "Unlimited phone audio": "Áudio de telefone ilimitado", "Desktop and mobile apps": "Aplicativos móveis e para área de trabalho", "Buy Now": "Compre agora", "Got it": "Entendi", "Web audio and dial-in": "Áudio e discagem na Web", "Screen sharing": "Compartilhamento de tela", "HD video conferencing": "Videoconferência em HD", "Drawing tools": "Ferramentas de desenho", "Recording": "Gravação", "Mobile apps": "Aplicativos móveis", "Keyboard & mouse sharing": "Compartilhamento de teclado e mouse", "Active directory": "Active Directory", "Virtual whiteboard": "Quadro de comunicações virtual", "Choose your plan": "Escolha seu plano", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "PLANO ATUAL", "Up to %s Attendees": "Até %s participantes", "per organizer, per month": "por organizador, por mês", "billed annually": "cobrança anual", "Select": "Selecionar", "Almost there!": "Quase lá!", "Choose your billing cycle and number of organizers": "Escolha seu ciclo de faturamento e o número de organizadores", "Plan": "Plano", "Billing Cycle": "Ciclo de faturamento", "No. of Organizers": "Número de organizadores", "My Total": "Meu total", "Change plan": "Alterar plano", "Annual": "Anual", "Monthly": "Mensal", "%s billed annually": "%s cobrado anualmente", "Save %s%%": "Economize %s%%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "Adicione os organizadores se mais de uma pessoa em sua equipe for agendar e hospedar suas próprias reuniões.", "for 1 year": "por 1 ano", "for 1 month": "por 1 mês", "Checkout": "Finalizar compra", "For more than 39 organizers, %scontact our sales team%s": "Para mais de 39 organizadores, %sentre em contato com nossa equipe de vendas%s" } }, "zh": { "translation": { "Your GoToMeeting Pro trial has ended...": "Your GoToMeeting Pro trial has ended...", "Your GoToMeeting Pro trial ends in 1 day...": "Your GoToMeeting Pro trial ends in 1 day...", "Your GoToMeeting Pro trial ends in %s days...": "Your GoToMeeting Pro trial ends in %s days...", "That means you're missing out on what GoToMeeting can offer, including ": "That means you're missing out on what GoToMeeting can offer, including ", "unlimited meetings with up to 150 participants": "unlimited meetings with up to 150 participants", ", powerful mobile apps and a whole lot more.": ", powerful mobile apps and a whole lot more.", "Don't lose access to these features": "Don't lose access to these features:", "Unlimited recording": "Unlimited recording", "Personal meeting room": "个人会议室", "Dial-in phone numbers": "Dial-in phone numbers", "HD video support for 25 webcams": "HD video support for 25 webcams", "Meeting transcriptions": "Meeting transcriptions", "SAVE UP TO": "SAVE UP TO", "20%": "20%", "OFF": "OFF", "Sign up for an annual plan today and save!": "Sign up for an annual plan today and save!", "Unlimited phone audio": "电话音频不受限制", "Desktop and mobile apps": "桌面和移动应用程序", "Buy Now": "立即购买", "Got it": "明白了", "Web audio and dial-in": "Web 音频和拨入", "Screen sharing": "桌面共享", "HD video conferencing": "高清视频会议", "Drawing tools": "绘图工具", "Recording": "录制", "Mobile apps": "移动应用程序", "Keyboard & mouse sharing": "键盘和鼠标共享", "Active directory": "Active Directory", "Virtual whiteboard": "虚拟白板", "Choose your plan": "选择您的计划", "Starter": "Starter", "Pro": "Pro", "Plus": "Plus", "CURRENT PLAN": "当前计划", "Up to %s Attendees": "最多 %s 位与会者", "per organizer, per month": "每位组织者，每月", "billed annually": "年付", "Select": "选择", "Almost there!": "检查并确认", "Choose your billing cycle and number of organizers": "选择您的账单周期和组织者数量", "Plan": "计划", "Billing Cycle": "账单周期", "No. of Organizers": "组织者数量", "My Total": "我的总费用", "Change plan": "更改计划", "Annual": "包年", "Monthly": "包月", "%s billed annually": "每年应付 %s", "Save %s%%": "节省 %s%%", "Add organizers if more than 1 person on your team will be scheduling and hosting their own meetings.": "如果您的团队中有多个人要安排并召开各自的会议，请添加多位组织者。", "for 1 year": "1 年", "for 1 month": "1 个月", "Checkout": "结算", "For more than 39 organizers, %scontact our sales team%s": "如果组织者数量超过 39，请%s联系我们的销售团队%s" } } };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(4);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextSprintfPostprocessor = __webpack_require__(99);
	
	var _i18nextSprintfPostprocessor2 = _interopRequireDefault(_i18nextSprintfPostprocessor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var language = _ref.language,
	      translations = _ref.translations;
	
	  _i18next2.default.use(_i18nextSprintfPostprocessor2.default).init({
	    lng: language,
	    fallbackLng: 'en',
	    keySeparator: false,
	    resources: translations,
	    overloadTranslationOptionHandler: _i18nextSprintfPostprocessor2.default.overloadTranslationOptionHandler
	  });
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(100).default;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _sprintf = __webpack_require__(101);
	
	exports.default = {
	  name: 'sprintf',
	  type: 'postProcessor',
	
	  process: function process(value, key, options) {
	    if (!options.sprintf) return value;
	
	    if (Object.prototype.toString.apply(options.sprintf) === '[object Array]') {
	      return (0, _sprintf.vsprintf)(value, options.sprintf);
	    } else if (_typeof(options.sprintf) === 'object') {
	      return (0, _sprintf.sprintf)(value, options.sprintf);
	    }
	
	    return value;
	  },
	  overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
	    var values = [];
	
	    for (var i = 1; i < args.length; i++) {
	      values.push(args[i]);
	    }
	
	    return {
	      postProcess: 'sprintf',
	      sprintf: values
	    };
	  }
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sprintf = sprintf;
	exports.vsprintf = vsprintf;
	var re = {
	    not_string: /[^s]/,
	    number: /[diefg]/,
	    json: /[j]/,
	    not_json: /[^j]/,
	    text: /^[^\x25]+/,
	    modulo: /^\x25{2}/,
	    placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
	    key: /^([a-z_][a-z_\d]*)/i,
	    key_access: /^\.([a-z_][a-z_\d]*)/i,
	    index_access: /^\[(\d+)\]/,
	    sign: /^[\+\-]/
	};
	
	function sprintf() {
	    var key = arguments[0],
	        cache = sprintf.cache;
	    if (!(cache[key] && cache.hasOwnProperty(key))) {
	        cache[key] = sprintf.parse(key);
	    }
	    return sprintf.format.call(null, cache[key], arguments);
	}
	
	sprintf.format = function (parse_tree, argv) {
	    var cursor = 1,
	        tree_length = parse_tree.length,
	        node_type = "",
	        arg,
	        output = [],
	        i,
	        k,
	        match,
	        pad,
	        pad_character,
	        pad_length,
	        is_positive = true,
	        sign = "";
	    for (i = 0; i < tree_length; i++) {
	        node_type = get_type(parse_tree[i]);
	        if (node_type === "string") {
	            output[output.length] = parse_tree[i];
	        } else if (node_type === "array") {
	            match = parse_tree[i]; // convenience purposes only
	            if (match[2]) {
	                // keyword argument
	                arg = argv[cursor];
	                for (k = 0; k < match[2].length; k++) {
	                    if (!arg.hasOwnProperty(match[2][k])) {
	                        throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]));
	                    }
	                    arg = arg[match[2][k]];
	                }
	            } else if (match[1]) {
	                // positional argument (explicit)
	                arg = argv[match[1]];
	            } else {
	                // positional argument (implicit)
	                arg = argv[cursor++];
	            }
	
	            if (get_type(arg) == "function") {
	                arg = arg();
	            }
	
	            if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && get_type(arg) != "number" && isNaN(arg)) {
	                throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)));
	            }
	
	            if (re.number.test(match[8])) {
	                is_positive = arg >= 0;
	            }
	
	            switch (match[8]) {
	                case "b":
	                    arg = arg.toString(2);
	                    break;
	                case "c":
	                    arg = String.fromCharCode(arg);
	                    break;
	                case "d":
	                case "i":
	                    arg = parseInt(arg, 10);
	                    break;
	                case "j":
	                    arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0);
	                    break;
	                case "e":
	                    arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential();
	                    break;
	                case "f":
	                    arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg);
	                    break;
	                case "g":
	                    arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg);
	                    break;
	                case "o":
	                    arg = arg.toString(8);
	                    break;
	                case "s":
	                    arg = (arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg;
	                    break;
	                case "u":
	                    arg = arg >>> 0;
	                    break;
	                case "x":
	                    arg = arg.toString(16);
	                    break;
	                case "X":
	                    arg = arg.toString(16).toUpperCase();
	                    break;
	            }
	            if (re.json.test(match[8])) {
	                output[output.length] = arg;
	            } else {
	                if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                    sign = is_positive ? "+" : "-";
	                    arg = arg.toString().replace(re.sign, "");
	                } else {
	                    sign = "";
	                }
	                pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " ";
	                pad_length = match[6] - (sign + arg).length;
	                pad = match[6] ? pad_length > 0 ? str_repeat(pad_character, pad_length) : "" : "";
	                output[output.length] = match[5] ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
	            }
	        }
	    }
	    return output.join("");
	};
	
	sprintf.cache = {};
	
	sprintf.parse = function (fmt) {
	    var _fmt = fmt,
	        match = [],
	        parse_tree = [],
	        arg_names = 0;
	    while (_fmt) {
	        if ((match = re.text.exec(_fmt)) !== null) {
	            parse_tree[parse_tree.length] = match[0];
	        } else if ((match = re.modulo.exec(_fmt)) !== null) {
	            parse_tree[parse_tree.length] = "%";
	        } else if ((match = re.placeholder.exec(_fmt)) !== null) {
	            if (match[2]) {
	                arg_names |= 1;
	                var field_list = [],
	                    replacement_field = match[2],
	                    field_match = [];
	                if ((field_match = re.key.exec(replacement_field)) !== null) {
	                    field_list[field_list.length] = field_match[1];
	                    while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                        if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                            field_list[field_list.length] = field_match[1];
	                        } else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                            field_list[field_list.length] = field_match[1];
	                        } else {
	                            throw new SyntaxError("[sprintf] failed to parse named argument key");
	                        }
	                    }
	                } else {
	                    throw new SyntaxError("[sprintf] failed to parse named argument key");
	                }
	                match[2] = field_list;
	            } else {
	                arg_names |= 2;
	            }
	            if (arg_names === 3) {
	                throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
	            }
	            parse_tree[parse_tree.length] = match;
	        } else {
	            throw new SyntaxError("[sprintf] unexpected placeholder");
	        }
	        _fmt = _fmt.substring(match[0].length);
	    }
	    return parse_tree;
	};
	
	function vsprintf(fmt, argv, _argv) {
	    _argv = (argv || []).slice(0);
	    _argv.splice(0, 0, fmt);
	    return sprintf.apply(null, _argv);
	}
	
	/**
	 * helpers
	 */
	function get_type(variable) {
	    return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
	}
	
	function str_repeat(input, multiplier) {
	    return Array(multiplier + 1).join(input);
	}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['G2M_Starter3', 'G2M_Pro2', 'G2M_Plus2'];

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectAllowedBundles = __webpack_require__(106);
	
	var _selectAllowedBundles2 = _interopRequireDefault(_selectAllowedBundles);
	
	var _orderBundles = __webpack_require__(107);
	
	var _orderBundles2 = _interopRequireDefault(_orderBundles);
	
	var _orderedG2mPlanNames = __webpack_require__(102);
	
	var _orderedG2mPlanNames2 = _interopRequireDefault(_orderedG2mPlanNames);
	
	var _addPlanDisplayNameAndPrimary = __webpack_require__(108);
	
	var _addPlanDisplayNameAndPrimary2 = _interopRequireDefault(_addPlanDisplayNameAndPrimary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (bundles) {
	  return (0, _addPlanDisplayNameAndPrimary2.default)((0, _orderBundles2.default)((0, _selectAllowedBundles2.default)(bundles, _orderedG2mPlanNames2.default), _orderedG2mPlanNames2.default));
	};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (bundles, allowedPlanNames) {
	  return bundles.filter(function (bundle) {
	    return bundle.plans.some(function (plan) {
	      return allowedPlanNames.indexOf(plan.name) > -1;
	    });
	  });
	};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (bundles, allowedPlanNames) {
	  return bundles.slice().sort(function (bundle1, bundle2) {
	    return allowedPlanNames.indexOf(bundle1.plans[0].name) - allowedPlanNames.indexOf(bundle2.plans[0].name);
	  });
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _planDisplayNameAndPrimaryTemplate = __webpack_require__(109);
	
	var _planDisplayNameAndPrimaryTemplate2 = _interopRequireDefault(_planDisplayNameAndPrimaryTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (bundles) {
	  return bundles.map(function (bundle, index) {
	    return Object.assign(bundle, _planDisplayNameAndPrimaryTemplate2.default[index]);
	  });
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{ displayName: 'Starter' }, { displayName: 'Pro', isPrimaryPlan: true }, { displayName: 'Plus' }];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=bundle.js.map;
